import React, { useEffect, useMemo, useState, useRef } from 'react';
import { get, isEmpty, isNil } from 'lodash';
import { injectIntl, IntlShape } from 'react-intl';
import { toast } from 'react-toastify';
import moment from 'moment';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import { isAllValuesIsNil } from 'helpers/utils';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { Container } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/styled-components';
import CorrectionalJudgement from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CorrectionalJudgement';
import {
  JudgementADDDocumentType,
  JudgementOnMeritsVictim,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import {
  ICivilJudgement,
  IJudgementAdd,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import {
  CONTESTATION,
  CONTESTATION_AGAINST,
  EMPTY_INVOICE_INFO,
  EMPTY_JUDGEMENT_ON_MERITS_DOC,
  PROCEDURE_STEPS,
  REJECTION_REASON,
} from 'containers/data-structure';
import { isUserActive } from 'containers/common/LegalProceedings/utils';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { BUTTON_COLORS, COLORS } from 'constants/design';
import {
  LEGAL_PROCEEDINGS_STEPS,
  PROCEDURE_STEPS_INDEX,
  PROCEDURE_TYPES,
} from 'containers/LawyerLegalProceedingsPage/constants';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { LISTINGS, PROCEDURE_STATUSES } from 'containers/data-structure';
import SuccessDialog from 'components/SuccessDialog';
import { PAGES } from 'routes';
import {
  CIVIL_JUDGEMENT_VICTIM_FIELDS,
  COMPTABLE_EXPERTISE_ID,
  JudgementOnMeritsDoc,
  JUDGEMENT_EXPERTISE_TYPES,
  MODE_TYPES,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import CivilJudgementRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap';
import { Config, Listings } from 'containers/AppContainer/typings';
import {
  disableValidationButton,
  getInjuredVictims,
  getMotifs,
  isContested,
  isCivilJudgementDefined,
  isRejected,
  resolveStatus,
  checkVictimExistanceCivilParty,
  hasOtherReason,
  getJudgementOnMeritsVictims,
  resolveJudiciaryProcessType,
  priorityClaimReason,
  formatExpertisesWithExpertReport,
  filterAccountingCivjs,
  getDeceasedVictims,
  disableSharedResponsibility,
  shouldValidateDesceasedVictims,
  getCivjvmInJudgement,
  validateCivilJudgementsOnRecap,
  filterExpertises,
  disableOnValidationButton,
  mapSagisEvaluation,
  mapCivilDocumentsEvaluations,
  mapJudiciaryProcessEvaluations,
  mapSagisEvaluationsWithoutExpertise,
  mapReasonWithoutCompensationEvaluations,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { pushTo } from 'containers/services/routes-helper';
import {
  useBeneficiaries,
  useDahirAmountByVictimKey,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/hooks';
import JudgementOnMeritsInfo from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/JudgementOnMeritsInfo';
import AdditionalInfoJudgementOnMerit from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/AdditionalInfoJudgementOnMerit';
import { ISuedPartyType } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/typings';
import { FormContainer } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/styled-components';

import DeceasedVictim from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/deceasedVictim';
import JudgementOnMeritsMotifRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/JudgementOnMeritsMotifRecap';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import CivilJudgementForm from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementForm';
import {
  formatInvoiceFeeNoteInfos,
  formatNextOfKins,
  formatVictimsToDahirAmount,
  getIntervenantInfo,
  isDeceasedVictimsOnly,
  isPendingApprovalClaim,
} from 'containers/LawyerLegalProceedingsPage/utils';

import InjuredVictim from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/injuredVictim';
import {
  addAccountingExpertiseAfterMerge,
  addNewCivjJudgement,
  addNewJudgementNonCompensation,
  formatAccExpertises,
  formatMechanicalExpertises,
  formatMedExpertises,
  getAllBeneficiaries,
  getCivilJudgement,
  getDeceasedVictim,
  getJudgementAddDocument,
  updateVehicleAccountingExpertiseAfterMerge,
} from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/utils';
import JudgementOnMeritsForm from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/JudgementOnMeritsForm';
import AdditionalInfoJudgementOnMeritForm from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/AdditionalInfoJudgementOnMeritsForm';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { useSelector } from 'react-redux';
import { INCIDENT_TYPE } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/constants';
import { mergeEvaluationsV2 } from 'containers/CourtManagerLegalProceedings/ExpertReport/utils';
import SahamDrawer from 'components/SahamDrawer';
import { getVictimFullName } from 'containers/LawyerLegalProceedingsPage/judgementAppeal/CivilJudgement/Expertises/utils';
import {
  getJudgementAddDocuments,
  resolveJudgementAddAppeal,
} from 'containers/LawyerLegalProceedingsPage/AppealOnMerits/utils';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import AddJomDrawer from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/AddJomDrawer';
import { Dialog } from 'containers/CourtManagerAssignedClaims/styled-components';
import {
  filterVictim,
  isBlockStatusClaim,
} from 'containers/CourtManagerLegalProceedings/utils';
import {
  STATUS_PENDING,
  STATUS_VALIDATED,
} from 'containers/LawyerFeeNote/constants';
import FirmReferenceForm from 'components/FirmReferenceForm';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import { getVehicleFromSagisInfo } from 'containers/PreOpeningPage/OpposingParty/utils';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import {
  formatCourtFileNumber,
  getPendingFeeNotesByStep,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import { resolveSagisClaim } from 'helpers/utils';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import {
  extractIntervenant,
  formatIntervenants,
} from 'containers/RecapPage/utils';
import InvoiceFeeNoteDialog from 'components/InvoiceFeeNoteDialog';
import InvoiceInfoDialog from 'components/InvoiceFeeNoteDialog/InvoiceInfoDialog';
import DynamiqDialog from 'components/InvoiceFeeNoteDialog/DynamiqDialog';
import InvoiceFeeNotesManagerDialog from 'components/InvoiceFeeNoteDialog/InvoiceFeeNotesManagerDialog';
import InjuredVictimsRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/InjuredVictimsRecap';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { CIVIL_JUDGEMENT_TYPES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/constants';
import { isExpertReportWithoutDecision } from 'containers/CourtManagerLegalProceedings/AppealOnMerits/utils';
import { FeeNoteType, VictimType } from 'typings/globalTypes';
import {
  getLimitInvoiceIntervenant,
  getLimitInvoiceManager,
} from 'services/utils';
import { makeSelectFeeNotes } from 'containers/LawyerFeeNote/selectors';

export interface JudgementOnMeritsProps {
  intl: IntlShape;
  listings: Listings;
  judgementAddDocuments: JudgementADDDocumentType[];
  uploadDocument: Function;
  setDocumentId: Function;
  documentId: string;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestCreateJudgementOnMerits: Function;
  judgementOnMerits: JudgementOnMeritsType;
  claimId: number;
  claimNumber: string;
  requestGetDahirAmount: Function;
  dahirAmount: [];
  judgementAdd: [];
  judgementAddClone: IJudgementAdd | {};
  policyInfo: { sagis: {} };
  judiciaryProcessId: number;
  civilProceeding: any;
  isManager: boolean;
  isCivilProceeding: boolean;
  requestInsertDahirAmountJom?: Function;
  requestGetDahirAmountCorpo?: Function;
  dahirAmountsCorpo?: any;
  victims?: any;
  requestAddJudgementOnMeritsSupportDocument: Function;
  requestValidateJudgementOnMerits?: Function;
  expertiseReport?: any;
  claim?: any;
  vehicules?: any;
  setJomLabels?: Function;
  allJudgementAddDocuments?: any;
  jomAssociatedVictims?: any;
  setJomAssociatedVictims?: Function;
  isMultiple?: boolean;
  currentJudiciaryProcess?: any;
  jomDeceasedVictims?: any;
  jomVictims?: number[] | undefined;
  jomVehicles?: number[] | undefined;
  setJomAppealLabels?: Function;
  setCurrentActiveTab?: Function;
  setCurrentJom?: Function;
  setCurrentInstanceTab?: Function;
  isAssignedLawyer: boolean;
  setDialogOpenFirmReference?: Function;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  judgementOnMeritsMultiple?: any;
  setIsButtonRedirect?: Function;
  requestMakeDecisionSupportDocument?: Function;
  imagineDocuments: any;
  isConsultation: boolean;
  requestGetDocByDocumentumId: Function;
}

export const JudgementOnMerits: React.FC<JudgementOnMeritsProps> = ({
  uploadDocument,
  listings,
  uploadedDocument,
  resetUploadedDocument,
  documentId,
  judgementAddDocuments,
  setDocumentId,
  requestCreateJudgementOnMerits,
  judgementOnMerits,
  claimId,
  claimNumber,
  dahirAmount,
  judgementAddClone,
  requestValidateJudgementOnMerits,
  expertiseReport,
  setJomLabels,
  allJudgementAddDocuments,
  isMultiple,
  currentJudiciaryProcess,
  setJomAppealLabels,
  setCurrentActiveTab,
  setCurrentJom,
  setCurrentInstanceTab,
  judgementOnMeritsMultiple,
  ...props
}): JSX.Element => {
  const [
    decisionGenerationFeeNote,
    setDecisionGenerationFeeNote,
  ] = React.useState(null);
  const [
    openInvoiceFeeNoteInfoDialog,
    setOpenInvoiceFeeNoteInfoDialog,
  ] = React.useState(false);
  const [
    openInvoiceUpdateFeeNoteInfoDialog,
    setOpenInvoiceUpdateFeeNoteInfoDialog,
  ] = React.useState(false);
  const [invoiceDocument, setInvoiceDocument] = React.useState({});
  const [invoiceNumber, setInvoiceNumber] = React.useState(null);
  const [invoiceDate, setInvoiceDate] = React.useState(null);

  const currentFeeNoteIndexRef = useRef<number>(0);
  const [currentFeeNoteIndex, setCurrentFeeNoteIndex] = useState<number | null>(
    null,
  );
  useEffect(() => {
    if (currentFeeNoteIndex !== null) {
      currentFeeNoteIndexRef.current = currentFeeNoteIndex;
    }
  }, [currentFeeNoteIndex]);

  const [invoiceFeeNotes, setInvoiceFeeNotes] = useState([]);
  const [generateFeeNoteLawyer, setGenerateFeeNoteLawyer] = React.useState<
    boolean
  >(false);
  const [openInvoiceInfoLawyers, setOpenInvoiceInfoLawyers] = React.useState<
    boolean
  >(false);
  const [invoiceFeeNoteInfos, setInvoiceFeeNoteInfo] = React.useState<any>([]);
  const [judgement, setJudgement] = useState({} as any);
  const [civilJudgements, setCivilJudgements] = useState([]);
  const [sharedResponsability, setSharedResponsability] = useState<string>('');
  useEffect(() => {
    setCivilJudgements([...getCivilJudgement(judgementOnMerits)] as any);
    setSharedResponsability(
      get(
        getCivilJudgement(judgementOnMerits),
        '[0].responsibilityShare',
        null,
      ) ||
        get(
          judgementOnMerits,
          'judgementOnMerits.jom.civjvm.[0].responsibilityShare',
          null,
        ) ||
        get(
          judgementOnMerits,
          'beneficiaries.[0].beneficiary.victim.responsibilityShare',
          null,
        ),
    );
  }, [judgementOnMerits]);

  const currentJudgementAddDocuments = allJudgementAddDocuments
    ? allJudgementAddDocuments
    : judgementAddDocuments;
  const filtredCvilProceeding = props.civilProceeding.find(
    (element: { id: number }) => element.id === props.judiciaryProcessId,
  );
  const civilVictimsToInclude = [
    ...get(filtredCvilProceeding, 'victims', []).map((vic: any) => vic.id),
    ...get(judgementAddClone, 'civilDocuments', [])
      .map((el: any) => get(el, 'victims', []))
      .flat()
      .map((vic: any) => vic.id),
  ];

  const jomVictimsToInclude = [...get(props, 'jomVictims', [])];

  const civilVehiclesToInclude = [
    ...get(filtredCvilProceeding, 'vehicules', []).map((v: any) => v.id),
  ];

  const jomVehiclesToInclude = [...get(props, 'jomVehicles', [])];

  const [judgementOnMeritsRequest, setJudgementOnMeritsRequest] = useState({
    document: null,
    cj:
      get(filtredCvilProceeding, 'procedureNatureId') === 3
        ? {
            suedPartys: [],
          }
        : {},
    civjs: [],
    jmv: get(judgementOnMerits, 'judgementOnMerits.jom.jmv', []),
    civjvm: [],
    civjVehicle: get(
      judgementOnMerits,
      'judgementOnMerits.jom.civjVehicle',
      [],
    ),
  });

  const claimAssignment = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'assignment'], []),
  );

  const claim = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim']),
  );

  const priorityReasonClaimId = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'priorityReasonId']),
  );
  const claimRecap = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap']),
  );
  const [lawyerFirmRef, setLawyerFirmRef] = React.useState(null);

  const lawyerAssignment = claimAssignment.find(
    (el: any) =>
      el.assignedLawyer === currentIntervenantStorage.get()?.sagis_code &&
      el.judiciaryProcessId === props.judiciaryProcessId &&
      el.isDeleted === false,
  );

  const lawyerFirmReference = get(lawyerAssignment, 'firmReference', null);
  const lawyerAssignmentDate = get(
    lawyerAssignment,
    'lawyerAssignmentDate',
    get(lawyerAssignment, 'createdAt', null),
  );
  const civilJudgementVictims = get(
    judgementOnMerits,
    'judgementOnMerits.jom.civjvm',
    [],
  ).filter((item: any) => !item?.expertiseJudgementAddDocumentId);
  const claimFeeNotes = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'feeNotes'], []),
  );
  const feeNotesStore = useSelector(makeSelectFeeNotes());
  const feeNoteAssignment = claimFeeNotes
    .sort(
      (a: any, b: any) =>
        new Date(get(a, 'createdAt')).getTime() -
        new Date(get(b, 'createdAt')).getTime(),
    )
    .find((el: any) =>
      el.judgementId
        ? el.judgementId === get(judgementOnMerits, 'judgementOnMerits.id') &&
          el.codeIntervenant === currentIntervenantStorage.get()?.sagis_code
        : el.step === PROCEDURE_STEPS.JUDGEMENT_ON_MERITS &&
          new Date(el.createdAt).getTime() >=
            new Date(
              get(judgementOnMerits, 'judgementOnMerits.createdAt'),
            ).getTime(),
    );

  const feeNotes = getPendingFeeNotesByStep(
    feeNotesStore,
    PROCEDURE_STEPS.JUDGEMENT_ON_MERITS,
    get(judgementOnMerits, 'judgementOnMerits.id'),
    [],
    currentIntervenantStorage?.get()?.sagis_code,
  );
  const [isCJDisabled, setIsCJDisabled] = useState({});

  const [
    correctionalJudgementOnMeritsForm,
    setCorrectionalJudgementOnMeritsForm,
  ] = useState<any>([]);

  const [judgementOnMeritsInfoForm, setJudgementOnMeritsInfoForm] = useState(
    {},
  );

  const [civilJudgementOnMeritsForm, setCivilJudgementOnMeritsForm] = useState<
    any
  >([]);
  const [
    civilJudgementOnMeritsFormMedicalExpertise,
    setCivilJudgementOnMeritsFormMedicalExpertise,
  ] = useState<any>([]);

  const [associatedVictims, setAssociatedVictims] = useState<any>([]);

  const [
    civilJudgementOnMeritsFormAccountingExpertise,
    setCivilJudgementOnMeritsFormAccountingExpertise,
  ] = useState<any>([]);

  const [
    civilJudgementOnMeritsFormMechanicalExpertise,
    setCivilJudgementOnMeritsFormMechanicalExpertise,
  ] = useState<any>([]);

  const [responsibilityRate, setResponsibilityRate] = useState(
    get(
      judgementOnMerits,
      '[judgementOnMerits][jom][civjs][0][responsibilityShare]',
      null,
    ),
  );
  const [dahirAmountByVictimKey] = useDahirAmountByVictimKey(
    props.victims
      .filter(
        (item: any) =>
          item.injuryPostKey === INJURY_POST_DECEASED &&
          !isEmpty(item?.victimKey),
      )
      .map((item: any) => item.victimKey),
    judgementAddDocuments,
    dahirAmount,
    {},
    props.victims
      .filter(
        (item: any) =>
          item.injuryPostKey !== INJURY_POST_DECEASED &&
          !isEmpty(item?.victimKey),
      )
      .map((item: any) => item.victimKey),
  );
  const [beneficiaries, setBeneficiaries] = useBeneficiaries(
    judgementOnMerits,
    judgementAddClone,
    [...get(props, 'jomDeceasedVictims', [])],
    dahirAmountByVictimKey,
    getDeceasedVictims(judgementAddClone, {}, filtredCvilProceeding),
    isMultiple,
  );
  const [civjvmRequest, setCivjvmRequest] = useState(
    get(judgementOnMerits, 'judgementOnMerits.jom.civjvm', []),
  );
  const handleCivJvmChange = (
    id: any | null,
    fieldName: string,
    victim?: any,
  ) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    let victimToUpdate: any =
      civjvmRequest.find((el: any) => el?.id === id) || {};
    const civilJudgementVictims = [...civjvmRequest];
    if (isEmpty(victimToUpdate) && victim && event.target.name) {
      const substrings = id.split('-');
      addNewJudgementNonCompensation(
        civilJudgementVictims,
        event,
        substrings,
        get(judgementOnMerits, 'judgementOnMerits.jom.id'),
        get(listings, 'civilJudgementVictimReason', []),
        victim,
        INCIDENT_TYPE.VICTIM,
      );
    }
    const index = civilJudgementVictims.findIndex(
      (item: any) => item.id === id,
    );
    if (index !== -1) {
      civilJudgementVictims[index] = {
        ...victimToUpdate,
        [fieldName]: event.target.value,
        otherReason: !hasOtherReason(
          get(listings, 'civilJudgementVictimReason', []),
          get(victimToUpdate, CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON, ''),
        )
          ? null
          : fieldName === CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON
          ? event.target.value
          : null,
      };
    }
    setCivjvmRequest(civilJudgementVictims);
  };

  const handleCivjVehicleChange = (
    id: any,
    fieldName: string,
    vehicle?: any,
  ) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    let vehicleToUpdate: any =
      get(judgementOnMeritsRequest, 'civjVehicle', []).find(
        (el: any) => el?.id === id,
      ) || {};

    const civilJudgementVehicles = [
      ...get(judgementOnMeritsRequest, 'civjVehicle', []),
    ] as any;
    const index = civilJudgementVehicles.findIndex(
      (item: any) => item.id === id,
    );

    if (isEmpty(vehicleToUpdate) && event.target.name) {
      const substrings = id.split('-');
      addNewJudgementNonCompensation(
        civilJudgementVehicles,
        event,
        substrings,
        get(judgementOnMerits, 'judgementOnMerits.jom.id'),
        get(listings, 'civilJudgementVictimReason', []),
        vehicle,
        INCIDENT_TYPE.VEHICLE,
      );
    }
    if (index !== -1) {
      civilJudgementVehicles[index] = {
        ...vehicleToUpdate,
        [fieldName]: event.target.value,
        responsibilityShare: sharedResponsability,
        otherReason: !hasOtherReason(
          get(listings, 'civilJudgementVictimReason', []),
          get(vehicleToUpdate, CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON, ''),
        )
          ? null
          : fieldName === CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON
          ? event.target.value
          : null,
      };
    }
    setJudgementOnMeritsRequest({
      ...judgementOnMeritsRequest,
      civjVehicle: civilJudgementVehicles,
    });
  };
  const [
    judgementOnMeritsFormDocument,
    setJudgementOnMeritsFormDocument,
  ] = useState({ ...EMPTY_JUDGEMENT_ON_MERITS_DOC });

  const [
    additionalJudgementOnMeritsInfoForm,
    setAdditionalJudgementOnMeritsInfoForm,
  ] = useState({});

  const lawyerInfo = getIntervenantInfo();
  const handleValidateUpdate = () => {
    if (
      featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) &&
      !isEmpty(feeNotes) &&
      currentIntervenantStorage.get()
    ) {
      setOpenInvoiceUpdateFeeNoteInfoDialog(true);
    } else {
      handleValidateJudgementOnMerits();
    }
  };
  const handleValidateJudgementOnMerits = (updatedInvoiceFeeNotes?: any) => {
    const sagisEvaluations = mapSagisEvaluation(
      get(expertiseReport, 'victimExpertises', []),
      desceasedVictim,
      isMultiple as any,
      judgement,
      judgementOnMeritsRequest,
      expertiseReport,
      civilJudgementOnMeritsForm,
      judgementOnMeritsInfo,
      getVictims(),
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'jomAssociatedVictims', []),
      listings,
      props.victims,
      props.judiciaryProcessId,
      claim,
    );
    const sagisEvalVictimKeys =
      sagisEvaluations && sagisEvaluations.map((el: any) => el?.victimKey);
    const civilDocumentsEvaluations = mapCivilDocumentsEvaluations(
      desceasedVictim,
      judgementAddClone,
      beneficiaries,
      sagisEvalVictimKeys,
      isMultiple,
      judgementOnMeritsRequest,
      judgementOnMeritsInfo,
      getVictims(),
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'jomAssociatedVictims', []),
      props.victims,
      props.judiciaryProcessId,
      claim,
    );
    const civilDocumentsVictimKeys =
      civilDocumentsEvaluations &&
      civilDocumentsEvaluations.map((el: any) => el.victimKey);
    const judiciaryProcessEvaluations = mapJudiciaryProcessEvaluations(
      get(filtredCvilProceeding, 'victims', []),
      beneficiaries,
      sagisEvalVictimKeys,
      civilDocumentsVictimKeys,
      isMultiple,
      desceasedVictim,
      judgementOnMeritsRequest,
      judgementOnMeritsInfo,
      getVictims(),
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'jomAssociatedVictims', []),
      props.victims,
      props.judiciaryProcessId,
      claim,
    );
    const sagisEvals = [
      ...mergeEvaluationsV2(
        [
          ...sagisEvaluations,
          ...civilDocumentsEvaluations,
          ...judiciaryProcessEvaluations,
        ],
        sharedResponsability,
      ),
    ];
    const contestationType = get(
      listings,
      'judgementOnMeritsContestationTypes',
      [],
    ).find(el => el.id === formContestationValues[CONTESTATION.TYPE])?.title;
    const validationRequest = {
      isLawyer: true,
      invoiceFeeNotes: updatedInvoiceFeeNotes,
      isContested: isContestationDrawerOpen,
      contestation: {},
      claimId: Number(claimId),
      claimNumber,
      status: PROCEDURE_STATUSES.PENDING,
      claimExtCode: claimNumber,
      judgementDate: moment(
        get(judgementOnMerits, 'judgementOnMerits.jom.judgementDate'),
      ).format('DD/MM/YYYY'),
      judgementId: get(judgementOnMerits['judgementOnMerits'], 'id'),
      info: {
        id: judgementOnMerits['judgementOnMerits']['jom']['id'],
        ...judgementOnMeritsInfoForm,
        ...additionalJudgementOnMeritsInfoForm,
      },
      jomId: get(judgementOnMerits, 'judgementOnMerits.jom.id', ''),
      document: {
        ...judgementOnMeritsFormDocument,
        judgementOnMeritsId:
          judgementOnMerits['judgementOnMerits']['jom']['id'],
        id:
          get(judgementOnMerits['judgementOnMerits']['jom'], 'document.id') &&
          get(judgementOnMerits['judgementOnMerits']['jom'], 'document.id'),
      },
      correctionalInfo: [
        ...correctionalJudgementOnMeritsForm.filter((el: any) => el.isModified),
      ],
      civilInfo: [
        ...civilJudgementOnMeritsForm.filter((el: any) => el.isModified),
      ],
      medExpertises: formatMedExpertises(
        civilJudgementOnMeritsFormMedicalExpertise,
      ),
      accExpertises: formatAccExpertises(
        civilJudgementOnMeritsFormAccountingExpertise,
      ),
      mechanicalExpertises: formatMechanicalExpertises(
        civilJudgementOnMeritsFormMechanicalExpertise,
      ),
      deceasedVictims: getDeceasedVictim(
        desceasedVictim,
        judgementAddClone,
        sharedResponsability as any,
      ),
      beneficiaries,
      isManager: userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER),
      procedureType: PROCEDURE_TYPES.FIRST_INSTANCE,
      fflipFeeNote: false,
      sagisEvaluations: [],
      provisionBody: {},
      judiciaryProcessId: get(
        judgementOnMerits['judgementOnMerits'],
        'judiciaryProcessId',
      ),
      civjvmInfo: civjvmRequest,
      civjVehicleInfo: get(judgementOnMeritsRequest, 'civjVehicle', []),
      isInboxesActive: featureService.hasFeature(
        FEATURES.ATTRIBUTION_INBOXES_MANAGER,
      ),
      isTrackingActive: featureService.hasFeature(
        FEATURES.TRACKING_ACTIONS_USER,
      ),
      jmv: get(
        judgementOnMeritsRequest,
        'jmv',
        [],
      ).filter((item: JudgementOnMeritsVictim) => get(item, 'updated', false)),
      isPriorityActive: featureService.hasFeature(FEATURES.PRIORITY_CLAIM),
      priorityClaimReasonId:
        featureService.hasFeature(FEATURES.PRIORITY_CLAIM) &&
        priorityReasonClaimId != 4
          ? priorityClaimReason(
              [...sagisEvals],
              !isEmpty(
                get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []),
              )
                ? get(resolveSagisClaim(props.policyInfo), 'offeredRisks', [])
                    .map((el: any) => Number(el.riskProvisions))
                    .reduce(
                      (accumulator: any, currentValue: any) =>
                        accumulator + currentValue,
                    )
                : 0,
              listings,
            )
          : undefined,
    };
    if (isContestationDrawerOpen) {
      validationRequest.status = PROCEDURE_STATUSES.OPPOSITION;
      validationRequest.contestation = {
        ...formContestationValues,
        victims: selectedVictims,
        beneficiaries: Object.values(selectedBeneficiaries),
        vehicules: selectedVehicles,
        contestationType,
        judgementOnMeritsId: get(
          judgementOnMerits,
          'judgementOnMerits.jom.id',
          '',
        ),
        status: STATUS_PENDING,
        difficultyExecution: IsDifficultyExecutionChecked,
        defenseExecution: isDefenseExecutionChecked,
      };
    }
    requestValidateJudgementOnMerits &&
      requestValidateJudgementOnMerits(
        validationRequest,
        successCallback(false),
      );
  };

  const [isSuccessPopinOpen, setIsSuccessPopinOpen] = useState<boolean>(false);

  const handleValidateUpdateInvoice = () => {
    const currentItem = feeNotes[currentFeeNoteIndexRef.current];
    const invoiceFeeNoteId = get(currentItem, 'invoiceFeeNote.id');
    const updatedInvoiceFeeNotes = [
      ...invoiceFeeNotes,
      {
        id: invoiceFeeNoteId,
        invoiceNumber: invoiceNumber,
        invoiceDate: invoiceDate,
        receptionDate: moment().format('YYYY-MM-DD'),
        ...invoiceDocument,
      },
    ];
    setInvoiceFeeNotes(updatedInvoiceFeeNotes as any);
    setInvoiceNumber(null);
    setInvoiceDocument({});
    setInvoiceDate(null);
    setOpenInvoiceUpdateFeeNoteInfoDialog(false);
    if (
      feeNotes &&
      updatedInvoiceFeeNotes.length ===
        feeNotes.map((el: any) => el.invoiceFeeNote).length
    ) {
      setCurrentFeeNoteIndex(null);
      handleValidateJudgementOnMerits(updatedInvoiceFeeNotes);
    } else {
      currentFeeNoteIndexRef.current = currentFeeNoteIndexRef.current + 1;
      setCurrentFeeNoteIndex(currentFeeNoteIndexRef.current);
      setOpenInvoiceUpdateFeeNoteInfoDialog(true);
    }
  };
  const handleSuedPartiesChange = (suedParties: ISuedPartyType[]) =>
    setJudgementOnMeritsRequest(
      Object.assign(
        {},
        { ...judgementOnMeritsRequest },
        {
          cj: {
            suedPartys: suedParties,
          },
        },
      ),
    );
  useEffect(() => {
    if (props.isManager) {
      if (
        !isEmpty(
          extractIntervenant(
            get(listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ),
        )
      ) {
        setInvoiceFeeNoteInfo(
          extractIntervenant(
            get(listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ).map((item: any, index: any) => ({
            codeIntervenant: item.ItemKey,
            createdBy:
              currentUserStorage?.get() && currentUserStorage?.get().username,
            ...EMPTY_INVOICE_INFO,
          })),
        );
      }
    }
  }, [props.judiciaryProcessId, currentJudiciaryProcess, !claimAssignment]);

  const doNotGenerateFeeNote = () => {
    createJudgementOnMerits(false);
  };
  const handleJudgementOnMeritsDocChange = (document: JudgementOnMeritsDoc) =>
    setJudgementOnMeritsRequest(
      Object.assign(
        {},
        { ...judgementOnMeritsRequest },
        {
          document,
        },
      ),
    );

  const [isAppealDialogOpen, setIsAppealDialogOpen] = useState(false);

  const handleValidateAppealDialog = () => {
    if (setJomAppealLabels)
      setJomAppealLabels([messages.appealOnMeritsLabelTitle]);
    setIsAppealDialogOpen(false);
    if (setCurrentJom) setCurrentJom(judgementOnMerits);
    if (setCurrentInstanceTab)
      setCurrentInstanceTab(PROCEDURE_STEPS_INDEX['APPEAL']);
    if (setCurrentActiveTab)
      setCurrentActiveTab(PROCEDURE_STEPS_INDEX['APPEAL']);
  };

  const handleCloseAppealDialog = () => {
    setIsAppealDialogOpen(false);
  };
  const createJudgementOnMerits = (withFeeNote: boolean) => {
    const sagisEvaluations = mapSagisEvaluation(
      get(expertiseReport, 'victimExpertises', []),
      desceasedVictim,
      isMultiple as any,
      judgement,
      judgementOnMeritsRequest,
      expertiseReport,
      civilJudgementOnMeritsForm,
      judgementOnMeritsInfo,
      getVictims(),
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'jomAssociatedVictims', []),
      listings,
      props.victims,
      props.judiciaryProcessId,
      claim,
      dahirAmount,
    );

    const sagisEvalVictimKeys =
      sagisEvaluations && sagisEvaluations.map((el: any) => el?.victimKey);
    const civilDocumentsEvaluations = mapCivilDocumentsEvaluations(
      desceasedVictim,
      judgementAddClone,
      beneficiaries,
      sagisEvalVictimKeys,
      isMultiple,
      judgementOnMeritsRequest,
      judgementOnMeritsInfo,
      getVictims(),
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'jomAssociatedVictims', []),
      props.victims,
      props.judiciaryProcessId,
      claim,
    );
    const civilDocumentsVictimKeys =
      civilDocumentsEvaluations &&
      civilDocumentsEvaluations.map((el: any) => el.victimKey);
    const judiciaryProcessEvaluations = mapJudiciaryProcessEvaluations(
      get(filtredCvilProceeding, 'victims', []),
      beneficiaries,
      sagisEvalVictimKeys,
      civilDocumentsVictimKeys,
      isMultiple,
      desceasedVictim,
      judgementOnMeritsRequest,
      judgementOnMeritsInfo,
      getVictims(),
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'jomAssociatedVictims', []),
      props.victims,
      props.judiciaryProcessId,
      claim,
    );
    const sagisEvaluationsWithoutExpertise = mapSagisEvaluationsWithoutExpertise(
      judgementAddDocuments,
      expertiseReport,
      judgementOnMerits,
      judgementOnMeritsRequest,
      sharedResponsability,
      judgement,
      judgementOnMeritsInfo,
      getVictims(),
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'victims', []),
      props.judiciaryProcessId,
      claim,
      dahirAmount,
    );
    const reasonWithoutCompensationEvaluations = mapReasonWithoutCompensationEvaluations(
      judgementOnMeritsRequest,
      sharedResponsability,
      judgementOnMeritsInfo,
      getVictims(),
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'victims', []),
      props.judiciaryProcessId,
      claim,
      expertiseReport,
      dahirAmount,
    );

    const sagisEvals = [
      ...mergeEvaluationsV2(
        [
          ...sagisEvaluations,
          ...civilDocumentsEvaluations,
          ...judiciaryProcessEvaluations,
        ],
        sharedResponsability,
      ),
      ...sagisEvaluationsWithoutExpertise,
      ...reasonWithoutCompensationEvaluations,
    ];
    !featureService.hasFeature(FEATURES.GET_DAHIR_AMOUNT_V2) &&
      props.requestInsertDahirAmountJom &&
      props.requestInsertDahirAmountJom(dahirAmountByVictimKey);
    props.setIsButtonRedirect && props.setIsButtonRedirect(true);
    const jomRequest = {
      ...judgementOnMeritsRequest,
      civjvm: Object.values(get(judgementOnMeritsRequest, 'civjvm'))
        .filter((item: any) => !isEmpty(item))
        .map((el: any) => ({
          ...el,
          responsibilityShare: parseFloat(sharedResponsability as any),
        })),
      civjs: get(judgementOnMeritsRequest, 'civjs', []).map((el: any) => ({
        ...el,
        responsibilityShare: parseFloat(sharedResponsability as any),
      })),
      civjVehicle: Object.values(
        get(judgementOnMeritsRequest, 'civjVehicle'),
      ).filter((item: any) => !isEmpty(item)),
      jmv: props.isManager
        ? getJudgementOnMeritsVictims(
            !isEmpty(judgementOnMerits)
              ? civilJudgements
              : get(judgementOnMeritsRequest, 'civjs', []),
            judgementOnMerits,
            judgementAddClone,
            {},
            filtredCvilProceeding,
            dahirAmountByVictimKey,
            parseFloat(sharedResponsability),
            get(judgementOnMeritsRequest, 'jmv', []),
            props.jomAssociatedVictims,
            props.jomDeceasedVictims,
            isMultiple,
          )
        : get(judgementOnMeritsRequest, 'jmv', []),
    };
    const nextOfKins = formatNextOfKins(beneficiaries, sharedResponsability);

    requestCreateJudgementOnMerits(
      {
        jom: {
          ...jomRequest,
          ...judgementOnMeritsInfo,
          judgementNumber: formatCourtFileNumber(
            judgementOnMeritsInfo.judgementNumber,
          ),
          lawyerCode: !props.isManager
            ? currentIntervenantStorage.get() &&
              currentIntervenantStorage.get().sagis_code
            : undefined,
        },
        lawyerFirmReference: lawyerFirmRef,
        assignementId: get(lawyerAssignment, 'id'),
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
        decisionGenerationFeeNote: decisionGenerationFeeNote,
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
        isTransactionActive: featureService.hasFeature(FEATURES.TRANSACTION),
        isCivilJudgementDefined: isCivilJudgementDefined(
          get(judgementAddClone, 'judgementAddDocuments', []),
        ),
        isJudiciaryProcessCorrectional:
          get(filtredCvilProceeding, 'procedureNatureId') === 3,
        claimId,
        claimNumber,
        isCompanyIntervenants: formatIntervenants(
          assignedLawyersByJudiciaryProcess,
        ),
        invoiceFeeNoteInfos:
          !isEmpty(invoiceFeeNoteInfos) &&
          props.isManager &&
          featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE)
            ? formatInvoiceFeeNoteInfos(invoiceFeeNoteInfos)
            : [],
        step: LEGAL_PROCEEDINGS_STEPS.JUDGEMENT_ON_MERITS,
        status: resolveStatus(
          get(filtredCvilProceeding, 'procedureNatureId', 0),
          props.isManager,
          featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER),
        ),
        deceasedVictims: desceasedVictim.map((el: any) => ({
          ...el,
          responsibilityShare: parseFloat(sharedResponsability as any),
        })),
        beneficiaries: checkVictimExistanceCivilParty(
          desceasedVictim as any,
          getVictims(),
        ).includes(true)
          ? beneficiaries.filter((el: any) =>
              !isEmpty(props.jomAssociatedVictims)
                ? props.jomAssociatedVictims.includes(get(el, 'victimId'))
                : true,
            )
          : [],
        nextOfKins: props.isManager && nextOfKins,
        procedureType: PROCEDURE_TYPES.FIRST_INSTANCE,
        sagisEvaluations: props.isManager && [...sagisEvals],
        provisionBody: props.isManager && {
          riskID: get(
            resolveSagisClaim(props.policyInfo),
            'offeredRisks',
            [],
          ).find(
            (element: { riskName: string }) => element.riskName === rcCoporeal,
          )?.riskId,
          date: moment().toISOString(true),
        },
        feeNote: withFeeNote
          ? {
              step: PROCEDURE_STEPS.JUDGEMENT_ON_MERITS,
              codeIntervenant: lawyerInfo.code,
              judgementDate: get(judgementOnMeritsInfo, 'judgementDate', ''),
              firmReference: isNil(lawyerFirmReference)
                ? lawyerFirmRef
                : lawyerFirmReference,
              courtNumber: `${resolveJudiciaryProcessType(
                get(filtredCvilProceeding, 'procedureNatureId'),
              )} ${formatCourtFileNumber(
                get(judgementOnMeritsInfo, 'judgementNumber'),
              )}`,
              invoiceFeeNote:
                featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
                !isAllValuesIsNil({
                  invoiceNumber: invoiceNumber,
                  invoiceDate: invoiceDate,
                  ...invoiceDocument,
                })
                  ? {
                      codeIntervenant: lawyerInfo.code,
                      createdBy:
                        currentIntervenantStorage?.get() &&
                        currentIntervenantStorage?.get()?.preferred_username,
                      invoiceNumber: invoiceNumber,
                      invoiceDate:
                        invoiceDate === 'Invalid date' ? null : invoiceDate,
                      receptionDate: moment().format('YYYY-MM-DD'),
                      ...invoiceDocument,
                      isIndexed: false,
                    }
                  : undefined,
            }
          : undefined,
        fflipFeeNote: props.isManager
          ? false
          : withFeeNote
          ? featureService.hasFeature(FEATURES.FEE_NOTE)
          : undefined,
        username: props.isManager
          ? currentUserStorage.get().username
          : currentIntervenantStorage.get().preferred_username,
        judiciaryProcessId: props.judiciaryProcessId,
        isLawyer: !props.isManager,
        isMultiple,
        isPriorityActive: featureService.hasFeature(FEATURES.PRIORITY_CLAIM),
        priorityClaimReasonId:
          featureService.hasFeature(FEATURES.PRIORITY_CLAIM) &&
          priorityReasonClaimId != 4
            ? priorityClaimReason(
                [...sagisEvals],
                !isEmpty(
                  get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []),
                )
                  ? get(resolveSagisClaim(props.policyInfo), 'offeredRisks', [])
                      .map((el: any) => Number(el.riskProvisions))
                      .reduce(
                        (accumulator: any, currentValue: any) =>
                          accumulator + currentValue,
                      )
                  : 0,
                listings,
              )
            : undefined,
        isLawyerInboxesActive: featureService.hasFeature(
          FEATURES.LAWYER_INBOXES,
        ),
      },
      successCallback(withFeeNote),
    );
  };
  const [contestationReasons, setContestationReasons] = useState<
    Set<{
      civilJudgementMedicalExpertiseId: number;
      civilJudgementMechanicalExpertiseId: number;
      civilJudgementAccountingExpertiseId: number;
      contestationReasons: Set<number>;
    }>
  >(new Set());
  const successCallback = (withFeeNote: boolean) => () => {
    if (withFeeNote && !props.isManager) {
      toast.success(translate(messages.jomToastSuccess, props));
      return pushTo(PAGES.FEE_NOTE)();
    } else if (!withFeeNote && !props.isManager) {
      return pushTo(PAGES.LAWYER_ASSIGNMENTS)();
    } else if (!featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)) {
      toast.success(translate(messages.jomToastSuccess, props));
      return pushTo(PAGES.COURT_MANAGER_ASSIGNED_CLAIM)();
    }
    toast.success(translate(messages.jomToastSuccess, props));
  };

  const handleClick = () => {
    createJudgementOnMerits(true);
  };

  const onValidate = () => {
    if (
      props.isManager &&
      featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER)
    ) {
      if (
        featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
        !isEmpty(
          extractIntervenant(
            get(listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ),
        )
      ) {
        return setGenerateFeeNoteLawyer(true);
      } else {
        return createJudgementOnMerits(true);
      }
    }
    if (
      props.isManager &&
      !featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER)
    ) {
      return createJudgementOnMerits(false);
    }
    if (isRejected(judgementOnMerits)) {
      if (currentIntervenantStorage.get()) {
        return handleValidateUpdate();
      } else {
        return handleValidateJudgementOnMerits();
      }
    }
    setIsSuccessPopinOpen(true);
  };

  const handleCorrectionalCondamnationChange = (id: number | undefined) => (
    e: React.ChangeEvent<{ value: string }>,
  ) => {
    const found = correctionalJudgementOnMeritsForm.find(
      (item: any) => item.id === id,
    );
    if (found) {
      found.isModified = true;
      found.condamnation = e.target.value;
    }
    setCorrectionalJudgementOnMeritsForm([
      ...correctionalJudgementOnMeritsForm,
    ]);
  };

  const handleCorrectionalSelectChange = (id: number | undefined) => (
    e: React.ChangeEvent<{ value: unknown }>,
  ) => {
    const found = correctionalJudgementOnMeritsForm.find(
      (item: any) => item.id === id,
    );
    if (found) {
      found.isModified = true;
      found.suedPartyId = e.target.value;
    }
    setCorrectionalJudgementOnMeritsForm([
      ...correctionalJudgementOnMeritsForm,
    ]);
  };

  const handleMedExpertiseChange = (id: number) => (
    expertiseId: number,
    type: number,
    incidentType: string,
    incident?: any,
  ) => (e: React.ChangeEvent<{ value: string; name: string }>) => {
    const civilJudgementOnMeritsFormMedicalExpertiseData = [
      ...civilJudgementOnMeritsFormMedicalExpertise,
    ];
    const civilJudgementMed = civilJudgementOnMeritsFormMedicalExpertise.find(
      (item: any) => item.id === id,
    );
    const civilJudgementOnMeritsFormAccountingExpertiseData = [
      ...civilJudgementOnMeritsFormAccountingExpertise,
    ];
    const civilJudgementData = [...civilJudgements];

    const medExp = get(civilJudgementMed, 'medExpertises', []).find(
      (item: any) => item.id === expertiseId,
    );
    const accountingExp = allJudgementDocuments
      .map((el: any) => {
        const victimExpertise = get(el, 'expertises', [])
          .filter(
            (item: any) => String(item.expertiseId) === COMPTABLE_EXPERTISE_ID,
          )
          .flatMap((expertise: any) => expertise.victims)
          .find((victim: VictimType) => victim.id === incident.id);
        return {
          id: el.id,
          expertiseJudgementAddDocumentId: get(
            victimExpertise,
            'expertiseJudgementAddDocumentId',
          ),
          victimId: get(victimExpertise, 'id'),
        };
      })
      .find((item: any) => !!item?.expertiseJudgementAddDocumentId);
    const accountingCivj = civilJudgements.find(
      (item: any) => item.judgementAddDocumentId === get(accountingExp, 'id'),
    );
    if (isEmpty(medExp) && e?.target.name) {
      addNewCivjJudgement(
        id,
        civilJudgementData,
        expertiseId,
        civilJudgementOnMeritsFormMedicalExpertiseData,
        e,
        CIVIL_JUDGEMENT_TYPES.MEDICAL,
        incidentType,
        incident,
      );
      !isEmpty(accountingExp) &&
        featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        addNewCivjJudgement(
          get(accountingCivj, 'id') as any,
          civilJudgements,
          `${get(accountingExp, 'victimId')}-${get(
            accountingExp,
            'expertiseJudgementAddDocumentId',
          )}`,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          e,
          CIVIL_JUDGEMENT_TYPES.ACCOUNTING,
          incidentType,
          incident,
        );
      setCivilJudgementOnMeritsFormMedicalExpertise(
        civilJudgementOnMeritsFormMedicalExpertiseData,
      );
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgements(civilJudgementData);
    } else if (!isEmpty(medExp)) {
      const civjWithoutCompensation = [...civjvmRequest];

      featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        addAccountingExpertiseAfterMerge(
          civilJudgements,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          medExp,
          type,
          e,
          civjWithoutCompensation,
          setCivjvmRequest,
          accountingExp,
        );
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgementOnMeritsFormMedicalExpertise([
        ...civilJudgementOnMeritsFormMedicalExpertise.filter(
          (el: any) => el.id !== civilJudgementMed.id,
        ),
        {
          id: civilJudgementMed.id,
          medExpertises: [
            ...civilJudgementMed.medExpertises.filter(
              (el: any) => el.id !== medExp.id,
            ),
            {
              ...medExp,
              id: medExp.id,
              compensationAmount:
                type === 0
                  ? e.target.value.replace(',', '.')
                  : medExp.compensationAmount,
              evaluationAmount:
                type === 2
                  ? e.target.value.replace(',', '.')
                  : medExp.evaluationAmount,
              provisionalExecution:
                type === 1
                  ? e.target.value.replace(',', '.')
                  : medExp.provisionalExecution,
            },
          ],
        },
      ]);
    }
  };

  const handleAccExpertiseChange = (id: number) => (
    expertiseId: number,
    type: number,
    incidentType: string,
    incident?: any,
  ) => (e: React.ChangeEvent<{ value: string; name: string }>) => {
    const civilJudgementOnMeritsFormAccountingExpertiseData = [
      ...civilJudgementOnMeritsFormAccountingExpertise,
    ];
    const civilJudgement = civilJudgementOnMeritsFormAccountingExpertise.find(
      (item: any) => item.id === id,
    );
    const accExp = civilJudgement.accExpertises.find(
      (item: any) => item.id === expertiseId,
    );
    if (isEmpty(accExp) && e?.target.name) {
      addNewCivjJudgement(
        id,
        civilJudgements,
        expertiseId,
        civilJudgementOnMeritsFormAccountingExpertiseData,
        e,
        CIVIL_JUDGEMENT_TYPES.ACCOUNTING,
        incidentType,
        incident,
      );
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
    } else if (!isEmpty(accExp))
      setCivilJudgementOnMeritsFormAccountingExpertise([
        ...civilJudgementOnMeritsFormAccountingExpertise.filter(
          (el: any) => el.id !== civilJudgement.id,
        ),
        {
          id: civilJudgement.id,
          accExpertises: [
            ...civilJudgement.accExpertises.filter(
              (el: any) => el.id !== accExp.id,
            ),
            {
              ...accExp,
              id: accExp.id,
              evaluationAmount: type ? accExp.evaluationAmount : e.target.value,
              provisionalExecution:
                type !== 1 ? accExp.provisionalExecution : e.target.value,
              calculatedRevenue:
                type !== 2 ? accExp.calculatedRevenue : e.target.value,
            },
          ],
        },
      ]);
  };

  const handleMechanicalExpertiseChange = (id: number) => (
    expertiseId: number,
    type: number,
    incidentType: string,
    incident: any,
  ) => (e: React.ChangeEvent<{ value: string; name: string }>) => {
    const civilJudgementOnMeritsFormMechanicalExpertiseData = [
      ...civilJudgementOnMeritsFormMechanicalExpertise,
    ];
    const civilJudgementOnMeritsFormAccountingExpertiseData = [
      ...civilJudgementOnMeritsFormAccountingExpertise,
    ];
    const civilJudgementData = [...civilJudgements];

    const civilJudgementMec = civilJudgementOnMeritsFormMechanicalExpertise.find(
      (item: any) => item.id === id,
    );

    const accountingExp = allJudgementDocuments
      .map((el: any) => {
        const vehicleExpertise = get(el, 'expertises', [])
          .filter(
            (item: any) => String(item.expertiseId) === COMPTABLE_EXPERTISE_ID,
          )
          .flatMap((expertise: any) => expertise.vehicules)
          .find((vehicle: any) => vehicle.id === incident.id);

        return {
          id: el.id,
          expertiseJudgementAddDocumentId: get(
            vehicleExpertise,
            'expertiseJudgementAddDocumentId',
          ),
          vehiculeId: get(vehicleExpertise, 'id'),
        };
      })
      .find((item: any) => !!item?.expertiseJudgementAddDocumentId);

    const accountingCivj = civilJudgements.find(
      (item: any) => item.judgementAddDocumentId === get(accountingExp, 'id'),
    );
    const meceExp = civilJudgementMec.mechanicalExpertise.find(
      (item: any) => item.id === expertiseId,
    );
    if (isEmpty(meceExp) && e?.target.name) {
      addNewCivjJudgement(
        id,
        civilJudgementData,
        expertiseId,
        civilJudgementOnMeritsFormMechanicalExpertiseData,
        e,
        CIVIL_JUDGEMENT_TYPES.MECHANICAL,
        incidentType,
        incident,
      );
      !isEmpty(accountingExp) &&
        featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        addNewCivjJudgement(
          get(accountingCivj, 'id') as any,
          civilJudgements,
          `${get(accountingExp, 'vehiculeId')}-${get(
            accountingExp,
            'expertiseJudgementAddDocumentId',
          )}`,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          e,
          CIVIL_JUDGEMENT_TYPES.ACCOUNTING,
          incidentType,
          incident,
        );
      setCivilJudgementOnMeritsFormMechanicalExpertise(
        civilJudgementOnMeritsFormMechanicalExpertiseData,
      );
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
    } else if (!isEmpty(meceExp)) {
      featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        updateVehicleAccountingExpertiseAfterMerge(
          civilJudgements,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          meceExp,
          type,
          e,
          accountingExp,
        );

      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgementOnMeritsFormMechanicalExpertise([
        ...civilJudgementOnMeritsFormMechanicalExpertise.filter(
          (el: any) => el.id !== civilJudgementMec.id,
        ),
        {
          id: civilJudgementMec.id,
          mechanicalExpertise: [
            ...civilJudgementMec.mechanicalExpertise.filter(
              (el: any) => el.id !== meceExp.id,
            ),
            {
              ...meceExp,
              id: meceExp.id,
              damageAmount: type ? meceExp.damageAmount : e.target.value,
              provisionalExecution: !type
                ? meceExp.provisionalExecution
                : e.target.value,
            },
          ],
        },
      ]);
    }
  };

  const handleCivilResponsabilityShareChange = (id: number | undefined) => (
    e: React.ChangeEvent<{ value: string }>,
  ) => {
    const found = civilJudgementOnMeritsForm.find(
      (item: any) => item.id === id,
    );
    if (found) {
      found.isModified = true;
      found.responsibilityShare = e.target.value;
    }
    setCivilJudgementOnMeritsForm([...civilJudgementOnMeritsForm]);
    setResponsibilityRate(e.target.value);
  };
  const [judgementOnMeritsInfo, setJudgementOnMeritsInfo] = useState({
    judgementNumber: isEmpty(judgementOnMerits)
      ? get(judgementAddClone, 'judgementAdd.courtFile', '')
      : get(judgementOnMerits, 'judgementOnMerits.jom.judgementNumber', ''),
  });

  const [desceasedVictim, setDesceasedVictim] = useState([]);
  const validateDesceasedVictim = shouldValidateDesceasedVictims(
    desceasedVictim,
    get(listings, 'civilJudgementVictimReason', []),
    get(judgementOnMeritsRequest, 'jmv', []),
    props,
  );
  const motifListCorrectional = [
    ...getMotifs(
      judgementOnMerits,
      get(listings, LISTINGS.JUDGEMENT_ON_MERITS_CONTESTATION_REASONS, []),
    ),
  ];
  motifListCorrectional.pop();
  useEffect(() => {
    props.requestGetDahirAmount(
      get(formatVictimsToDahirAmount(get(props, 'victims', [])), 'injured', []),
      get(
        formatVictimsToDahirAmount(get(props, 'victims', [])),
        'deceased',
        [],
      ),
    );
  }, []);

  useEffect(() => {
    if (!isEmpty(judgementOnMerits)) {
      const suedParties =
        get(
          judgementOnMerits['judgementOnMerits']['jom']['cj'],
          'suedPartys',
        ) &&
        get(
          judgementOnMerits['judgementOnMerits']['jom']['cj'],
          'suedPartys',
        ).map(el => {
          return {
            id: el.id,
            condamnation: el.condamnation,
            suedPartyId: el.suedPartyId,
            isModified: false,
          };
        });
      const responsabilityShares = judgementOnMerits['judgementOnMerits'][
        'jom'
      ]['civjs'].map(el => {
        return {
          id: el.id,
          responsibilityShare: el.responsibilityShare,
          isModified: false,
        };
      });
      const civjVictimAccountings = civilJudgements
        .flatMap((item: any) => item.civjacce)
        .filter((el: any) => !!el.victim);

      const medicalExpertises = judgementOnMerits['judgementOnMerits']['jom'][
        'civjs'
      ].map(el => {
        const medExpertises = el['civjmede'].map((item: any) => {
          const accountingExpertise =
            civjVictimAccountings.find(el => el.victimId === item.victimId) ||
            {};
          return {
            id: item.id,
            compensationAmount: item.compensationAmount,
            provisionalExecution: item.provisionalExecution,
            victimId: item?.victimId,
            expertiseJudgementAddDocumentId:
              item?.expertiseJudgementAddDocumentId,
            evaluationAmount: get(
              accountingExpertise,
              'evaluationAmount',
              null,
            ),
          };
        });
        return {
          id: el.id,
          medExpertises: [...medExpertises],
        };
      });
      const accountingExpertises = judgementOnMerits['judgementOnMerits'][
        'jom'
      ]['civjs'].map(el => {
        const accExpertises = el['civjacce'].map((item: any) => {
          return {
            id: item.id,
            evaluationAmount: item.evaluationAmount,
            provisionalExecution: item.provisionalExecution,
            calculatedRevenue: item.calculatedRevenue,
            expertiseJudgementAddDocumentId:
              item?.expertiseJudgementAddDocumentId,
            victimId: get(item, 'victimId', null),
            vehiculeId: get(item, 'vehiculeId', null),
          };
        });
        return {
          id: el.id,
          accExpertises: [...accExpertises],
        };
      });
      const mechanicalExpertises = judgementOnMerits['judgementOnMerits'][
        'jom'
      ]['civjs'].map(el => {
        const mechanicalExpertise = get(el, 'civjmece', []).map((item: any) => {
          return {
            id: item.id,
            damageAmount: item.damageAmount,
            provisionalExecution: item.provisionalExecution,
            expertiseJudgmentAddDocumentId:
              item?.expertiseJudgmentAddDocumentId,
            vehiculeId: item?.vehiculeId,
          };
        });
        return {
          id: el.id,
          mechanicalExpertise: [...mechanicalExpertise],
        };
      });
      if (suedParties) {
        setCorrectionalJudgementOnMeritsForm([...suedParties]);
      }
      setCivilJudgementOnMeritsForm([...responsabilityShares]);
      setCivilJudgementOnMeritsFormMedicalExpertise([...medicalExpertises]);
      setCivilJudgementOnMeritsFormAccountingExpertise([
        ...accountingExpertises,
      ]);
      setCivilJudgementOnMeritsFormMechanicalExpertise([
        ...mechanicalExpertises,
      ]);
    } else {
      const responsabilityShares = get(
        judgementOnMeritsRequest,
        'civjs',
        [],
      ).map((el: any) => {
        return {
          id: el.id,
          responsibilityShare: el.responsibilityShare,
          isModified: false,
        };
      });
      const civjVictimAccountings = civilJudgements
        .flatMap((item: any) => item.civjacce)
        .filter((el: any) => !!el.victim);

      const medicalExpertises = get(judgementOnMeritsRequest, 'civjs', []).map(
        (el: any) => {
          const medExpertises = get(el, 'civjmede', []).map((item: any) => {
            const accountingExpertise =
              civjVictimAccountings.find(el => el.victimId === item.victimId) ||
              {};
            return {
              id: item.id,
              compensationAmount: item.compensationAmount,
              provisionalExecution: item.provisionalExecution,

              victimId: item?.victimId,
              expertiseJudgementAddDocumentId:
                item?.expertiseJudgementAddDocumentId,
              evaluationAmount: get(
                accountingExpertise,
                'evaluationAmount',
                null,
              ),
            };
          });
          return {
            id: el.id,
            medExpertises: [...medExpertises],
          };
        },
      );
      const accountingExpertises = get(
        judgementOnMeritsRequest,
        'civjs',
        [],
      ).map((el: any) => {
        const accExpertises = get(el, 'civjacce', []).map((item: any) => {
          return {
            id: item.id,
            evaluationAmount: item.evaluationAmount,
            provisionalExecution: item.provisionalExecution,
            calculatedRevenue: item.calculatedRevenue,
            expertiseJudgementAddDocumentId:
              item?.expertiseJudgementAddDocumentId,
            victimId: get(item, 'victimId', null),
            vehiculeId: get(item, 'vehiculeId', null),
          };
        });
        return {
          id: el.id,
          accExpertises: [...accExpertises],
        };
      });
      const mechanicalExpertises = get(
        judgementOnMeritsRequest,
        'civjs',
        [],
      ).map((el: any) => {
        const mechanicalExpertise = get(el, 'civjmece', []).map((item: any) => {
          return {
            id: item.id,
            damageAmount: item.damageAmount,
            provisionalExecution: item.provisionalExecution,
            expertiseJudgmentAddDocumentId:
              item?.expertiseJudgmentAddDocumentId,
            vehiculeId: item?.vehiculeId,
          };
        });
        return {
          id: el.id,
          mechanicalExpertise: [...mechanicalExpertise],
        };
      });
      setCivilJudgementOnMeritsForm([...responsabilityShares]);
      setCivilJudgementOnMeritsFormMedicalExpertise([...medicalExpertises]);
      setCivilJudgementOnMeritsFormAccountingExpertise([
        ...accountingExpertises,
      ]);
      setCivilJudgementOnMeritsFormMechanicalExpertise([
        ...mechanicalExpertises,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [judgementOnMerits, props.judiciaryProcessId]);

  const getVictims = () =>
    props.isCivilProceeding
      ? get(props, 'civilProceeding', []).find(
          (cp: any) => cp.id === props.judiciaryProcessId,
        ).victims
      : props.judgementAdd
          .map((document: any) => get(document, 'victims', []))
          .flat();

  const [isContestationDrawerOpen, setIsContestationDrawerOpen] = useState(
    false,
  );

  const [isAddJomDrawerOpen, setIsAddJomDrawerOpen] = useState(false);

  const [associatedVehicles, setAssociatedVehicles] = useState<any>([]);

  const [formContestationValues, setFormContestationValues] = useState<any>({
    [CONTESTATION.TYPE]: null,
  });
  const [isInputChanged, setIsInputChanged] = useState<boolean>(true);

  const [selectedVictims, setSelectedVictims] = useState<any>([]);

  const [selectedBeneficiaries, setSelectedBeneficiaries] = useState<any>({});

  const [selectedVehicles, setSelectedVehicles] = useState<any>([]);

  const [isDefenseExecutionChecked, setIsDefenseExecutionChecked] = useState<
    boolean
  >(false);

  const [
    IsDifficultyExecutionChecked,
    setIsDifficultyExecutionChecked,
  ] = useState<boolean>(false);
  const assignedLawyersByJudiciaryProcess = claimAssignment.filter(
    (el: any) =>
      el.judiciaryProcessId === props.judiciaryProcessId &&
      el.isDeleted === false,
  );
  const handleFormChange = (fieldName: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
  ) =>
    setFormContestationValues(
      Object.assign(
        {},
        { ...formContestationValues },
        { [fieldName]: event.target.value },
      ),
    );
  const IsVictimChecked = (victimId: number, selectedVictims: any): boolean => {
    const found = selectedVictims.find((el: any) => el === victimId);
    if (found) return true;
    return false;
  };

  const handleVictimChangeCheckBox = (victimId: number) => (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const selectedVictim = props.victims.find((el: any) => el.id === victimId);
    if (event.target.checked) {
      setSelectedVictims([...selectedVictims, selectedVictim.id]);
    } else {
      let uncheckVictimBeneficiaries = { ...selectedBeneficiaries };
      const findBeneficiaryVictim = Object.values(
        uncheckVictimBeneficiaries,
      ).find((beneficiary: any) => beneficiary.victimId === victimId);
      delete uncheckVictimBeneficiaries[
        `${get(findBeneficiaryVictim, 'id', '')}`
      ];
      selectedVictims.splice(
        selectedVictims.findIndex((el: number) => el === victimId),
        1,
      );
      setSelectedVictims([...selectedVictims]);
      setSelectedBeneficiaries(uncheckVictimBeneficiaries);
    }
  };

  const isBeneficiaryChecked = (beneficiaryId: number) =>
    Boolean(
      Object.values(selectedBeneficiaries).find(
        ({ id }: any) => id === beneficiaryId,
      ),
    );

  const handleBeneficiaryCheckBox = (
    victimId: number,
    beneficiaryId: number,
    beneficiaries: [{ id: number; victimId: number }],
  ) => (
    event: React.ChangeEvent<{ id: string; value: string; checked: boolean }>,
  ) => {
    const selectedBeneficiary: any = beneficiaries.find(
      (el: any) => el.id === beneficiaryId,
    );

    if (event.target.checked) {
      setSelectedBeneficiaries({
        ...selectedBeneficiaries,
        ...{
          [selectedBeneficiary.id]: { id: selectedBeneficiary.id, victimId },
        },
      });
    } else {
      let selectedBeneficiary = { ...selectedBeneficiaries };
      delete selectedBeneficiary[
        `${Object.keys(selectedBeneficiary).find(
          (el: any) => Number(el) === beneficiaryId,
        )}`
      ];
      setSelectedBeneficiaries(selectedBeneficiary);
    }
  };

  const IsVehicleChecked = (
    vehicleId: number,
    selectedVehicles: any,
  ): boolean => {
    const found = selectedVehicles.find((el: any) => el === vehicleId);
    if (found) return true;
    return false;
  };

  const handleDifficultyExecutionCheckBox = () => {
    setIsDifficultyExecutionChecked(!IsDifficultyExecutionChecked);
  };

  const handleDefenseExecutionCheckBox = () => {
    setIsDefenseExecutionChecked(!isDefenseExecutionChecked);
  };

  const handleVehicleChangeCheckBox = (vehicleId: number) => (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const selectedVehicle = props.vehicules.find(
      (el: any) => el.id === vehicleId,
    );

    if (event.target.checked) {
      setSelectedVehicles([...selectedVehicles, selectedVehicle.id]);
    } else {
      selectedVehicles.splice(
        selectedVehicles.findIndex((el: number) => el === vehicleId),
        1,
      );
      setSelectedVehicles([...selectedVehicles]);
    }
  };

  const allJudgementDocuments = useMemo(
    () =>
      getJudgementAddDocuments(judgementAddDocuments, [], judgementOnMerits),
    [judgementAddDocuments, judgementOnMerits],
  );
  const [dropDown, setDropDown] = useState(null);

  const validateCivilJudgements = validateCivilJudgementsOnRecap(
    filterExpertises(
      formatExpertisesWithExpertReport(
        allJudgementDocuments,
        get(expertiseReport, 'victimExpertises', []),
        get(expertiseReport, 'vehiculeExpertises', []),
      ),
    ),
    formatExpertisesWithExpertReport(
      allJudgementDocuments,
      get(expertiseReport, 'victimExpertises', []),
      get(expertiseReport, 'vehiculeExpertises', []),
    ),
    judgement,
    civilJudgementOnMeritsFormMedicalExpertise,
    civilJudgementOnMeritsFormAccountingExpertise,
    civilJudgementOnMeritsFormMechanicalExpertise,
    civjvmRequest,
    get(judgementOnMeritsRequest, 'civjVehicle', []),
    get(listings, 'civilJudgementVictimReason', []),
    [],
    {},
    isCJDisabled,
    judgementOnMerits,
  );
  const resolveDropDownMenuElements = () => {
    const jomJmc = get(judgementOnMerits, 'judgementOnMerits.jom.jmc', '');
    const jomStatus = get(judgementOnMerits, 'judgementOnMerits.status', '');

    return [
      {
        title: translate(messages.lawyercontestationType, props),
        action: () => setIsContestationDrawerOpen(true),
        disabled: !(
          isEmpty(jomJmc) && jomStatus !== PROCEDURE_STATUSES.REJECTED
        ),
      },

      {
        title: translate(messages.addJom, props),
        action: () => setIsAddJomDrawerOpen(true),
      },
      {
        title: translate(messages.addJomAppeal, props),
        action: () => setIsAppealDialogOpen(true),
        disabled: jomStatus !== PROCEDURE_STATUSES.APPEL,
      },
    ];
  };

  const handleToggleAddJomDrawer = () => {
    setIsAddJomDrawerOpen(!isAddJomDrawerOpen);
  };
  const handleOpenInvoicesInfoDialog = () => {
    setIsSuccessPopinOpen(false);
    setOpenInvoiceFeeNoteInfoDialog(true);
  };
  const handleCloseSuccessDialog = () => {
    setIsSuccessPopinOpen(false);
    doNotGenerateFeeNote();
  };
  const handleValidateInvoice = () => {
    handleClick();
    setOpenInvoiceFeeNoteInfoDialog(false);
  };
  const handleCloseInvoiceFeeNote = () => {
    setOpenInvoiceFeeNoteInfoDialog(false);
  };
  const handleCloseInvoiceUpdateFeeNote = () => {
    setOpenInvoiceUpdateFeeNoteInfoDialog(false);
  };
  const handleSubmitCreateJom = () => {
    setIsAddJomDrawerOpen(false);
    if (setJomLabels) setJomLabels([messages.judgementOnMeritsLabelTitle]);
    if (props.setJomAssociatedVictims)
      props.setJomAssociatedVictims(associatedVictims);
  };
  const isCreator =
    get(judgementOnMerits, 'judgementOnMerits.lawyerCode', '') ===
    currentIntervenantStorage.get()?.sagis_code;

  const handleChangeSharedResponsability = (
    e: React.ChangeEvent<{ value: string }>,
  ) => {
    if (parseFloat(e.target.value) >= 0) {
      setIsInputChanged(false);
      setSharedResponsability(e.target.value.replace(',', '.'));
    }
  };

  const handleOpenInvoicesInfoLawyersDialog = () => {
    setGenerateFeeNoteLawyer(false);
    setOpenInvoiceInfoLawyers(true);
  };

  const feeNoteToGenerate = {
    step: PROCEDURE_STEPS.JUDGEMENT_ON_MERITS,
    codeIntervenant: lawyerInfo.code,
    judgementDate: get(
      judgementOnMerits,
      'judgementOnMerits.jom.judgementDate',
      null,
    ),
    judgementId: get(judgementOnMerits, 'judgementOnMerits.id', null),
    firmReference: lawyerFirmReference,
    status:
      get(judgementOnMerits, 'judgementOnMerits.status', null) ===
      PROCEDURE_STATUSES.REJECTED
        ? PROCEDURE_STATUSES.REJECTED
        : PROCEDURE_STATUSES.PENDING,
    comment:
      get(judgementOnMerits, 'judgementOnMerits.status', null) ===
      PROCEDURE_STATUSES.REJECTED
        ? REJECTION_REASON
        : null,
    claimNumber,
    courtNumber: `${resolveJudiciaryProcessType(
      get(filtredCvilProceeding, 'procedureNatureId'),
    )} ${formatCourtFileNumber(get(judgementOnMeritsInfo, 'judgementNumber'))}`,
  };

  const currentlawyerAssignment =
    claimAssignment.find(
      (el: any) =>
        el.judiciaryProcessId === props.judiciaryProcessId &&
        el.isDeleted === false,
    ) || {};
  return props.isAssignedLawyer ||
    (!props.isAssignedLawyer && !isEmpty(judgementOnMerits)) ? (
    <Container id="judgement-on-merits-wrapper">
      {props.isManager && (
        <div style={{ fontWeight: 'bold', fontSize: '18px', color: 'red' }}>
          {!isUserActive(
            listings,
            get(currentlawyerAssignment, 'assignedLawyer'),
          ) &&
          !isEmpty(currentlawyerAssignment) &&
          !isEmpty(listings)
            ? translate(messages.userNotValidWarning, props, {
                lawyerName: getValueByCode(
                  get(currentlawyerAssignment, 'assignedLawyer', ''),
                  get(listings, 'inactiveIntervenants', []),
                ),
              })
            : ''}
        </div>
      )}
      {props.isManager && isExpertReportWithoutDecision(expertiseReport) && (
        <div style={{ fontWeight: 'bold', fontSize: '18px', color: 'red' }}>
          {translate(messages.expertReportWithoutDecision, props)}
        </div>
      )}
      {lawyerAssignment &&
        !isBlockStatusClaim(props.policyInfo) &&
        !props.isManager && (
          <FirmReferenceForm
            firmReference={
              feeNoteAssignment
                ? get(feeNoteAssignment, 'firmReference')
                : lawyerFirmReference
            }
            message={
              lawyerFirmReference === null &&
              (feeNoteAssignment || isEmpty(judgementOnMerits))
                ? translate(messages.lawyerFirmReferenceUpdateMessage, props)
                : translate(messages.lawyerFirmReferenceEditMessage, props)
            }
            formInputLabel={translate(
              messages.lawyerFirmReferenceDialogLabel,
              props,
            )}
            formInputName={translate(
              messages.lawyerFirmReferenceDialogLabel,
              props,
            )}
            validationButtonTitle={
              lawyerFirmReference === null && isEmpty(judgementOnMerits)
                ? translate(messages.saveButton, props)
                : !isEmpty(judgementOnMerits) && !feeNoteAssignment
                ? translate(messages.generateFeeNote, props)
                : translate(messages.editButton, props)
            }
            setIsDialogOpenFirmReference={props.setDialogOpenFirmReference}
            title={
              get(judgementOnMerits, 'judgementOnMerits.creator', '')
                ? translate(messages.creatorTitle, props, {
                    lawyer: get(
                      judgementOnMerits,
                      'judgementOnMerits.creator',
                      '',
                    ),
                  })
                : ''
            }
            isFeeNoteGenerated={feeNoteAssignment}
            isForm={isEmpty(judgementOnMerits)}
            isPronoucing={false}
            feeNote={feeNoteToGenerate}
            isAssignmentDateValid={
              isEmpty(judgementOnMerits) ||
              new Date(lawyerAssignmentDate).getTime() <=
                new Date(
                  get(judgementOnMerits, 'judgementOnMerits.createdAt', null),
                ).getTime()
            }
            lawyerFirmReference={lawyerFirmReference}
            assignment={lawyerAssignment}
            judiciaryProcessId={props.judiciaryProcessId}
          />
        )}
      <div>
        <div className="judgement-on-merits-title">
          {translate(messages.judgementOnMeritsInfo, props, {
            jomId: !isNil(
              get(
                judgementOnMerits,
                'judgementOnMerits.jom.judgementDate',
                null,
              ),
            )
              ? props.intl.formatDate(
                  get(judgementOnMerits, 'judgementOnMerits.jom.judgementDate'),
                  {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  },
                )
              : '',
          })}
          {get(judgementOnMerits, 'judgementOnMerits.rejectionReason', '') &&
            get(judgementOnMerits, 'judgementOnMerits.status', '') ===
              PROCEDURE_STATUSES.REJECTED && (
              <span style={{ marginLeft: '10px', color: COLORS.RED }}>
                {translate(messages.rejectedTitle, props)}
                {` : ${get(
                  judgementOnMerits,
                  'judgementOnMerits.rejectionReason',
                )}`}
              </span>
            )}
        </div>
        {!isRejected(judgementOnMerits) ? (
          <JudgementOnMeritsInfo
            judgementOnMeritsInfo={judgementOnMeritsInfo}
            setJudgementOnMeritsInfo={setJudgementOnMeritsInfo}
            judgementOnMerits={judgementOnMerits}
            judgementAddDocuments={judgementAddDocuments}
          />
        ) : (
          <JudgementOnMeritsForm
            judgementOnMeritsInfoForm={judgementOnMeritsInfoForm}
            setJudgementOnMeritsInfoForm={setJudgementOnMeritsInfoForm}
            judgementOnMerits={judgementOnMerits}
          />
        )}
        {isEmpty(judgementOnMerits)
          ? get(filtredCvilProceeding, 'procedureNatureId') === 3 && (
              <>
                <div className="judgement-on-merits-title">
                  {translate(messages.correctionalJudgementTitle, props)}
                </div>
                <CorrectionalJudgement
                  listings={listings}
                  judgementOnMerits={judgementOnMerits}
                  handleSuedPartiesChange={handleSuedPartiesChange}
                />
              </>
            )
          : get(filtredCvilProceeding, 'procedureNatureId') === 3 && (
              <>
                <div className="judgement-on-merits-title">
                  {translate(messages.correctionalJudgementTitle, props)}
                </div>
                <div className="correctional-judgement">
                  <Grid container>
                    <Grid item xs={9}>
                      {isRejected(judgementOnMerits) &&
                        get(
                          judgementOnMerits['judgementOnMerits']['jom']['cj'],
                          'suedPartys',
                        ) &&
                        get(
                          judgementOnMerits['judgementOnMerits']['jom']['cj'],
                          'suedPartys',
                        ).map((el: ISuedPartyType, index: number) => (
                          <>
                            <FormContainer>
                              <div className="condamnation-textfield">
                                <TextField
                                  label={translate(
                                    { ...messages.condamnationFieldTitle },
                                    props,
                                  )}
                                  onChange={handleCorrectionalCondamnationChange(
                                    el?.id,
                                  )}
                                  value={
                                    correctionalJudgementOnMeritsForm.find(
                                      (item: any) => item.id === el.id,
                                    )
                                      ? correctionalJudgementOnMeritsForm.find(
                                          (item: any) => item.id === el.id,
                                        ).condamnation
                                      : ''
                                  }
                                />
                              </div>
                              <FormControl className="input-fields">
                                <InputLabel>
                                  {translate(messages.suedPartyTitle, props)}
                                </InputLabel>
                                <Select
                                  value={
                                    correctionalJudgementOnMeritsForm.find(
                                      (item: any) => item.id === el.id,
                                    )
                                      ? correctionalJudgementOnMeritsForm.find(
                                          (item: any) => item.id === el.id,
                                        ).suedPartyId
                                      : ''
                                  }
                                  onChange={handleCorrectionalSelectChange(
                                    el?.id,
                                  )}
                                >
                                  {!isEmpty(get(listings, 'suedParty', [])) &&
                                    listings.suedParty.map(suedParty => (
                                      <MenuItem
                                        value={suedParty.id}
                                        key={suedParty.id}
                                      >
                                        {suedParty.title}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                            </FormContainer>
                          </>
                        ))}
                      {!isRejected(judgementOnMerits) &&
                        get(
                          judgementOnMerits['judgementOnMerits']['jom'],
                          'cj.suedPartys',
                        ) &&
                        get(
                          judgementOnMerits['judgementOnMerits']['jom'],
                          'cj.suedPartys',
                        ).map((el: ISuedPartyType) => (
                          <>
                            <FormContainer>
                              <div className="condamnation-textfield">
                                <TextField
                                  label={translate(
                                    { ...messages.condamnationFieldTitle },
                                    props,
                                  )}
                                  defaultValue={el.condamnation}
                                  InputProps={{ readOnly: true }}
                                />
                              </div>
                              <FormControl className="input-fields-1">
                                <InputLabel>
                                  {translate(messages.suedPartyTitle, props)}
                                </InputLabel>
                                <Select value={el.suedPartyId} disabled={true}>
                                  {!isEmpty(get(listings, 'suedParty', [])) &&
                                    listings.suedParty.map(suedParty => (
                                      <MenuItem
                                        value={suedParty.id}
                                        key={suedParty.id}
                                      >
                                        {suedParty.title}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                            </FormContainer>
                          </>
                        ))}
                    </Grid>
                    <Grid item xs={3}>
                      {!isEmpty(motifListCorrectional) && (
                        <JudgementOnMeritsMotifRecap
                          motifs={getMotifs(
                            judgementOnMerits,
                            get(
                              listings,
                              LISTINGS.JUDGEMENT_ON_MERITS_CONTESTATION_REASONS,
                              [],
                            ),
                          )}
                        />
                      )}
                    </Grid>
                  </Grid>
                </div>
              </>
            )}

        {!isEmpty(judgementOnMerits) && civilJudgements && (
          <>
            <div className="judgement-on-merits-title">
              {translate(messages.sharedResponsability, props)}
            </div>
            <div className="shared-responsability">
              <TextField
                name={'sharedResponsability'}
                data-testId="shared-responsability"
                label={translate(messages.sharedResponsability, props)}
                value={sharedResponsability}
                error={disableSharedResponsibility(
                  sharedResponsability,
                  beneficiaries,
                  get(judgementOnMeritsRequest, 'civjs', []),
                )}
                helperText={
                  disableSharedResponsibility(
                    sharedResponsability,
                    beneficiaries,
                    get(judgementOnMeritsRequest, 'civjs', []),
                  ) && translate(messages.validateRequiredField, props)
                }
                onChange={handleChangeSharedResponsability}
                className="shared-responsability-field"
                disabled={
                  props.isManager &&
                  get(judgementOnMerits, 'status') !== STATUS_VALIDATED
                }
                InputProps={{
                  inputProps: {
                    min: 0,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      {translate(
                        { ...messages.responsibiltySharePercentage },
                        props,
                      )}
                    </InputAdornment>
                  ),
                }}
                type="number"
              />
            </div>
          </>
        )}
        {!isEmpty(civilJudgementVictims) && (
          <>
            <div className="judgement-on-merits-title">
              {translate(messages.injuredVictim, props)}
            </div>
            <div className="judgement-add-doc">
              {civjvmRequest
                .filter((item: any) => !item.expertiseJudgementAddDocumentId)
                .map((civjvm: any) => {
                  return (
                    <InjuredVictimsRecap
                      listings={listings}
                      judgementOnMeritsRequest={judgementOnMeritsRequest}
                      isManager={userPrivileges.userHasPrivilege(
                        PRIVILEGES.ISCOURTMANAGER,
                      )}
                      modeType={MODE_TYPES.RECAP}
                      judgement={judgement}
                      setJudgement={setJudgement}
                      judgementForNonCompensation={
                        JUDGEMENT_EXPERTISE_TYPES.NON_COMPENSATION
                      }
                      civjvms={civjvmRequest.filter(
                        (item: any) => !item.expertiseJudgementAddDocumentId,
                      )}
                      civjWithNonCompensation={civjvm}
                      handleCivJvmChange={handleCivJvmChange}
                      judgementOnMerits={judgementOnMerits}
                      sagisVictimInfo={props.sagisVictimInfo}
                      victim={{
                        id: get(civjvm, 'victimId'),
                        ...get(civjvm, 'victim', {}),
                      }}
                      expertiseJudgementAddDocumentId={get(
                        civjvm,
                        'expertiseJudgementAddDocumentId',
                      )}
                      civj={{}}
                      setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
                      civjvmRequest={civjvmRequest}
                      setCivjvmRequest={setCivjvmRequest}
                      setCivilJudgements={setCivilJudgements}
                      civilJudgements={civilJudgements}
                      isDisabled={
                        !props.isManager && !isRejected(judgementOnMerits)
                      }
                      dahirAmount={dahirAmount}
                    />
                  );
                })}
            </div>
          </>
        )}
        {filterAccountingCivjs(
          civilJudgements,
          civjvmRequest,
          get(judgementOnMeritsRequest, 'civjVehicle', []),
          judgementAddDocuments,
        ).map((civilJudgement: ICivilJudgement, index: number) => (
          <>
            <div className="judgement-add-doc-title">
              {translate(messages.judgementCivilRecap, props, {
                index: index + 1,
                date: props.intl.formatDate(civilJudgement.createdAt, {
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }),
              })}
            </div>
            <div key={civilJudgement.id} className="judgement-add-doc">
              <CivilJudgementRecap
                isRejected={isRejected(judgementOnMerits)}
                listings={listings}
                contestationReasons={contestationReasons}
                setContestationReasons={setContestationReasons}
                civilJudgement={civilJudgement}
                isContested={isContested(judgementOnMerits)}
                dahirAmount={
                  dahirAmountByVictimKey as {
                    [key: string]: number;
                  }
                }
                responsabilityShareValue={
                  civilJudgementOnMeritsForm.find(
                    (item: any) => item.id === civilJudgement.id,
                  )
                    ? civilJudgementOnMeritsForm.find(
                        (item: any) => item.id === civilJudgement.id,
                      ).responsibilityShare
                    : ''
                }
                handleCivilResponsabilityShareChange={handleCivilResponsabilityShareChange(
                  civilJudgement.id,
                )}
                medicalExpertise={civilJudgementOnMeritsFormMedicalExpertise.find(
                  (item: any) => item.id === civilJudgement.id,
                )}
                handleMedExpertiseChange={handleMedExpertiseChange(
                  civilJudgement.id,
                )}
                accountingExpertise={civilJudgementOnMeritsFormAccountingExpertise.find(
                  (item: any) => item.id === civilJudgement.id,
                )}
                handleAccExpertiseChange={handleAccExpertiseChange(
                  civilJudgement.id,
                )}
                civilJudgementMechanicalExpertise={civilJudgementOnMeritsFormMechanicalExpertise.find(
                  (item: any) => item.id === civilJudgement.id,
                )}
                handleMechanicalExpertiseChange={handleMechanicalExpertiseChange(
                  civilJudgement.id,
                )}
                sagisVictimInfo={props.sagisVictimInfo}
                sagisOpposingParties={props.sagisOpposingParties}
                judgementOnMeritsRequest={judgementOnMeritsRequest}
                setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
                judgement={judgement}
                setJudgement={setJudgement}
                civjvmRequest={civjvmRequest}
                handleCivJvmChange={handleCivJvmChange}
                judgementOnMerits={judgementOnMerits}
                civilJudgementOnMeritsFormAccountingExpertise={
                  civilJudgementOnMeritsFormAccountingExpertise
                }
                setCivilJudgementOnMeritsFormAccountingExpertise={
                  setCivilJudgementOnMeritsFormAccountingExpertise
                }
                civilJudgementOnMeritsFormMedicalExpertise={
                  civilJudgementOnMeritsFormMedicalExpertise
                }
                setCivilJudgementOnMeritsFormMedicalExpertise={
                  setCivilJudgementOnMeritsFormMedicalExpertise
                }
                civilJudgementOnMeritsFormMechanicalExpertise={
                  civilJudgementOnMeritsFormMechanicalExpertise
                }
                setCivilJudgementOnMeritsFormMechanicalExpertise={
                  setCivilJudgementOnMeritsFormMechanicalExpertise
                }
                setCivjvmRequest={setCivjvmRequest}
                civilJudgements={civilJudgements}
                setCivilJudgements={setCivilJudgements}
                handleCivjVehicleChange={handleCivjVehicleChange}
                judgementAddDocument={getJudgementAddDocument(
                  civilJudgement,
                  judgementAddDocuments,
                  get(expertiseReport, 'victimExpertises', []),
                  get(expertiseReport, 'vehiculeExpertises', []),
                )}
                expertiseReport={expertiseReport}
                judgementAddDocuments={formatExpertisesWithExpertReport(
                  judgementAddDocuments,
                  get(expertiseReport, 'victimExpertises', []),
                  get(expertiseReport, 'vehiculeExpertises', []),
                )}
              />
            </div>
          </>
        ))}
        {isEmpty(judgementOnMerits) && (
          <>
            <div className="judgement-on-merits-title">
              {translate(messages.sharedResponsability, props)}
            </div>
            <div className="shared-responsability">
              <TextField
                name={'sharedResponsability'}
                data-testId="shared-responsability"
                label={translate(messages.sharedResponsability, props)}
                value={sharedResponsability}
                onChange={handleChangeSharedResponsability}
                className="shared-responsability-field"
                InputProps={{
                  inputProps: {
                    min: 0,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      {translate(
                        { ...messages.responsibiltySharePercentage },
                        props,
                      )}
                    </InputAdornment>
                  ),
                }}
                type="number"
                error={disableSharedResponsibility(
                  sharedResponsability,
                  beneficiaries,
                  get(judgementOnMeritsRequest, 'civjs', []),
                )}
                helperText={
                  disableSharedResponsibility(
                    sharedResponsability,
                    beneficiaries,
                    get(judgementOnMeritsRequest, 'civjs', []),
                  ) && translate(messages.validateRequiredField, props)
                }
              />
            </div>
          </>
        )}
        {!isEmpty(
          getInjuredVictims(currentJudgementAddDocuments, getVictims()),
        ) && (
          <InjuredVictim
            victims={getInjuredVictims(
              currentJudgementAddDocuments,
              getVictims(),
            )}
            judgementOnMerits={judgementOnMerits}
            setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
            judgementOnMeritsRequest={judgementOnMeritsRequest}
            judgementAddDocuments={currentJudgementAddDocuments}
            isMultiple={isMultiple}
            listings={listings}
            sagisVictimInfo={props.sagisVictimInfo}
            setJudgement={setJudgement}
            judgement={judgement}
            jomAssociatedVictims={props.jomAssociatedVictims}
          />
        )}
        <>
          {!isDeceasedVictimsOnly(getVictims()) &&
            isEmpty(judgementOnMerits) && (
              <CivilJudgementForm
                judgementOnMeritsRequest={judgementOnMeritsRequest}
                setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
                dahirAmount={dahirAmountByVictimKey}
                judgementOnMerits={judgementOnMerits}
                judgementAddDocuments={judgementAddDocuments}
                isDisabled={isCJDisabled}
                setIsDisabled={setIsCJDisabled}
                isAppeal={false}
                allJudgementDocuments={resolveJudgementAddAppeal(
                  allJudgementDocuments,
                  false,
                  null,
                )}
                sharedResponsability={sharedResponsability}
                sagisVictimInfo={props.sagisVictimInfo}
                sagisOpposingParties={props.sagisOpposingParties}
                victims={props.victims}
                injuredVictims={getInjuredVictims(
                  currentJudgementAddDocuments,
                  getVictims(),
                )}
                isMultiple={isMultiple}
                listings={listings}
                setJudgement={setJudgement}
                judgement={judgement}
                expertiseReport={expertiseReport}
              />
            )}
        </>

        {isEmpty(judgementOnMerits) ? (
          <DeceasedVictim
            isRecap={false}
            beneficiairies={beneficiaries}
            judgementAdd={judgementAddClone}
            listing={listings}
            handleChangeDesceasedVictim={setDesceasedVictim}
            desceasedVictims={desceasedVictim}
            handleChangeBeneficiaries={setBeneficiaries}
            isContested={isContested(judgementOnMerits)}
            dahirAmount={dahirAmountByVictimKey}
            currentJudiciaryProcess={filtredCvilProceeding}
            victims={props.victims}
            allVictims={getVictims()}
            isManager={userPrivileges.userHasPrivilege(
              PRIVILEGES.ISCOURTMANAGER,
            )}
            judgementOnMerits={judgementOnMerits}
            associatedVictims={props.jomAssociatedVictims}
            jomDeceasedVictims={props.jomDeceasedVictims}
            isMultiple={isMultiple}
            sharedResponsability={sharedResponsability as any}
            judgementOnMeritsRequest={judgementOnMeritsRequest}
            setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
            dahirAmountByVictimKey={dahirAmountByVictimKey}
            lossDate={get(claimRecap, 'claim.lossDate')}
          />
        ) : (
          (!isEmpty(judgementOnMerits['beneficiaries']) ||
            !isEmpty(get(judgementAddClone, 'deceasedVictim'))) && (
            <DeceasedVictim
              beneficiairies={beneficiaries}
              isRecap
              judgementAdd={judgementAddClone}
              listing={listings}
              handleChangeDesceasedVictim={setDesceasedVictim}
              handleChangeBeneficiaries={setBeneficiaries}
              RecapInfo={judgementOnMerits['beneficiaries']}
              desceasedVictims={desceasedVictim}
              isContested={isContested(judgementOnMerits)}
              dahirAmount={dahirAmountByVictimKey}
              currentJudiciaryProcess={filtredCvilProceeding}
              victims={props.victims}
              judgementOnMerits={judgementOnMerits}
              isManager={userPrivileges.userHasPrivilege(
                PRIVILEGES.ISCOURTMANAGER,
              )}
              allVictims={getVictims()}
              associatedVictims={props.jomAssociatedVictims}
              jomDeceasedVictims={props.jomDeceasedVictims}
              isMultiple={isMultiple}
              sharedResponsability={sharedResponsability as any}
              judgementOnMeritsRequest={judgementOnMeritsRequest}
              setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
              dahirAmountByVictimKey={dahirAmountByVictimKey}
              lossDate={get(claimRecap, 'claim.lossDate')}
            />
          )
        )}
        <div className="judgement-on-merits-title">
          {translate(messages.judgementOnMeritsAdditionalInfo, props)}
        </div>
        {isRejected(judgementOnMerits) && (
          <AdditionalInfoJudgementOnMeritForm
            additionalJudgementOnMeritsInfoForm={
              additionalJudgementOnMeritsInfoForm
            }
            judgementOnMeritsFormDocument={judgementOnMeritsFormDocument}
            setJudgementOnMeritsFormDocument={setJudgementOnMeritsFormDocument}
            setAdditionalJudgementOnMeritsInfoForm={
              setAdditionalJudgementOnMeritsInfoForm
            }
            judgementOnMerits={judgementOnMerits}
            resetUploadedDocument={resetUploadedDocument}
            uploadDocument={uploadDocument}
            handleJudgementOnMeritsDocChange={() => {}}
            uploadedDocument={uploadedDocument}
            setDocumentId={setDocumentId}
            documentId={documentId}
            requestAddJudgementOnMeritsSupportDocument={
              props.requestAddJudgementOnMeritsSupportDocument
            }
            claimId={claimId}
            claimNumber={claimNumber}
            isCivilProceeding={props.isCivilProceeding}
            isAssignedLawyer={props.isAssignedLawyer}
            isCreator={isCreator}
            claim={props.claim}
            judiciaryProcessId={props.judiciaryProcessId}
            imagineDocuments={props.imagineDocuments}
            policyInfo={props.policyInfo}
            listings={listings}
            isConsultation={props.isConsultation}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        )}

        {!isRejected(judgementOnMerits) && (
          <AdditionalInfoJudgementOnMerit
            judgementOnMeritsInfo={judgementOnMeritsInfo}
            setJudgementOnMeritsInfo={setJudgementOnMeritsInfo}
            judgementOnMerits={judgementOnMerits}
            resetUploadedDocument={resetUploadedDocument}
            uploadDocument={uploadDocument}
            uploadedDocument={uploadedDocument}
            handleJudgementOnMeritsDocChange={handleJudgementOnMeritsDocChange}
            setDocumentId={setDocumentId}
            documentId={documentId}
            isManager={props.isManager}
            requestAddJudgementOnMeritsSupportDocument={
              props.requestAddJudgementOnMeritsSupportDocument
            }
            claimId={claimId}
            claimNumber={claimNumber}
            isAssignedLawyer={props.isAssignedLawyer}
            requestMakeDecisionSupportDocument={
              props.requestMakeDecisionSupportDocument
            }
            judiciaryProcessId={get(
              judgementOnMerits['judgementOnMerits'],
              'judiciaryProcessId',
            )}
            claim={claim}
            imagineDocuments={props.imagineDocuments}
            policyInfo={props.policyInfo}
            listings={listings}
            isConsultation={props.isConsultation}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        )}
      </div>
      {(isEmpty(judgementOnMerits) ||
        (isRejected(judgementOnMerits) && isCreator)) &&
        !userPrivileges.userHasPrivilege(
          PRIVILEGES.ISCOURTMONITORINGMANAGER,
        ) && (
          <>
            <section className="submit-form">
              <SecondaryButton
                title={translate(messages.goBackButton, props)}
                data-testid="go-back"
              />
              <PrimaryButton
                disabled={
                  !isEmpty(judgementOnMerits)
                    ? disableOnValidationButton(
                        judgementOnMeritsInfoForm,
                        validateDesceasedVictim,
                        getAllBeneficiaries(desceasedVictim),
                        validateCivilJudgements,
                        sharedResponsability,
                        civilJudgementOnMeritsFormMedicalExpertise,
                        civilJudgementOnMeritsFormAccountingExpertise,
                        civilJudgementOnMeritsFormMechanicalExpertise,
                        get(listings, 'civilJudgementVictimReason', []),
                        get(judgementOnMeritsRequest, 'civjs', []),
                        getVictims(),
                        civjvmRequest,
                        allJudgementDocuments,
                      )
                    : disableValidationButton(
                        judgementOnMerits,
                        filtredCvilProceeding,
                        judgementOnMeritsRequest,
                        props.isCivilProceeding,
                        judgementOnMeritsInfo,
                        isCJDisabled,
                        isRejected(judgementOnMerits),
                        judgementAddDocuments,
                        sharedResponsability,
                        beneficiaries,
                        validateDesceasedVictim,
                        get(listings, 'civilJudgementVictimReason', []),
                        getVictims(),
                        isExpertReportWithoutDecision(expertiseReport),
                        props.isManager,
                        [
                          ...Object.values(
                            get(judgementOnMeritsRequest, 'civjvm'),
                          ),
                          ...getCivjvmInJudgement(judgementOnMeritsMultiple),
                        ],
                        props.jomAssociatedVictims,
                      )
                }
                data-testid="validate"
                background={BUTTON_COLORS.PRIMARY_BLUE}
                border={BUTTON_COLORS.PRIMARY_BLUE}
                titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                title={translate(messages.validateButton, props)}
                onClick={onValidate}
              />
            </section>
            {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) ? (
              <InvoiceFeeNoteDialog
                open={isSuccessPopinOpen}
                onClose={() => setIsSuccessPopinOpen(false)}
                decisionGenerationFeeNote={decisionGenerationFeeNote}
                setDecisionGenerationFeeNote={setDecisionGenerationFeeNote}
                handleValidate={
                  decisionGenerationFeeNote
                    ? handleOpenInvoicesInfoDialog
                    : handleCloseSuccessDialog
                }
                shouldDisplayFirmReferenceField={
                  isEmpty(lawyerFirmReference) && !props.isManager
                }
                setLawyerFirmRef={setLawyerFirmRef}
                lawyerFirmRef={lawyerFirmRef}
              />
            ) : (
              <SuccessDialog
                title={translate(messages.successDialogTitle, props)}
                secondaryButtonTitle={translate(
                  messages.successDialogSecondaryButtonTitle,
                  props,
                )}
                primaryButtonTitle={
                  featureService.hasFeature(FEATURES.FEE_NOTE)
                    ? translate(
                        messages.successDialogPrimaryButtonTitleJdd,
                        props,
                      )
                    : translate(messages.successDialogPrimaryButtonTitle, props)
                }
                tertiaryButtonTitle={translate(
                  { ...messages.doNotGenerateFeeNote },
                  props,
                )}
                onTertiaryClick={doNotGenerateFeeNote}
                open={isSuccessPopinOpen && !props.isManager}
                onClose={setIsSuccessPopinOpen}
                homePath={PAGES.LAWYER_HOME}
                isExpertReport={false}
                onPrimaryClick={handleClick}
                isPrimaryButtonDisabled={isEmpty(lawyerFirmReference)}
              />
            )}
            {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
              <InvoiceInfoDialog
                open={openInvoiceFeeNoteInfoDialog}
                onClose={handleCloseInvoiceFeeNote}
                handleValidate={handleValidateInvoice}
                invoiceNumber={invoiceNumber}
                invoiceDate={invoiceDate}
                setInvoiceNumber={setInvoiceNumber}
                setInvoiceDate={setInvoiceDate}
                resetUploadedDocument={resetUploadedDocument}
                uploadDocument={uploadDocument}
                uploadedDocument={uploadedDocument}
                invoiceDocument={invoiceDocument}
                setInvoiceDocument={setInvoiceDocument}
                limitInvoiceDate={getLimitInvoiceIntervenant(
                  get(listings, 'appConfig', []),
                )}
              />
            )}
          </>
        )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
        props.isManager && (
          <InvoiceFeeNoteDialog
            open={generateFeeNoteLawyer}
            onClose={() => setGenerateFeeNoteLawyer(false)}
            decisionGenerationFeeNote={decisionGenerationFeeNote}
            setDecisionGenerationFeeNote={setDecisionGenerationFeeNote}
            handleValidate={
              decisionGenerationFeeNote
                ? handleOpenInvoicesInfoLawyersDialog
                : () => {
                    setInvoiceFeeNoteInfo([]);
                    createJudgementOnMerits(false);
                    setGenerateFeeNoteLawyer(false);
                  }
            }
            shouldDisplayFirmReferenceField={
              isEmpty(lawyerFirmReference) && !props.isManager
            }
            setLawyerFirmRef={setLawyerFirmRef}
            lawyerFirmRef={lawyerFirmRef}
          />
        )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
        <DynamiqDialog
          open={openInvoiceInfoLawyers}
          onClose={() => setOpenInvoiceInfoLawyers(false)}
          handleValidate={() => {
            createJudgementOnMerits(true);
            setOpenInvoiceInfoLawyers(false);
          }}
          children={
            <>
              {extractIntervenant(
                get(listings, 'intervenants'),
                assignedLawyersByJudiciaryProcess,
              ).map((item: any, index: any) => (
                <div style={{ marginTop: 10 }}>
                  <Typography style={{ fontWeight: 700 }}>
                    {translate(messages.intervenantName, props, {
                      IntervenantName: get(item, 'ItemDescription', null),
                    })}
                  </Typography>
                  <InvoiceFeeNotesManagerDialog
                    invoiceFeeNoteInfo={invoiceFeeNoteInfos[index]}
                    listings={listings}
                    invoiceFeeNoteInfos={invoiceFeeNoteInfos}
                    resetUploadedDocument={resetUploadedDocument}
                    uploadedDocument={uploadedDocument}
                    uploadDocument={uploadDocument}
                    assignedLawyersByJudiciaryProcess={
                      assignedLawyersByJudiciaryProcess
                    }
                    setDocumentId={setDocumentId}
                    setInvoiceFeeNoteInfo={setInvoiceFeeNoteInfo}
                    documentId={documentId}
                    index={index}
                    displayFirmReferenceInput={
                      isNil(get(item, 'firmReference', null)) &&
                      featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE)
                    }
                    limitInvoiceDate={getLimitInvoiceManager(
                      get(listings, 'appConfig', []),
                    )}
                  />
                </div>
              ))}
            </>
          }
        />
      )}
      {!isEmpty(judgementOnMerits) &&
        !isRejected(judgementOnMerits) &&
        props.isAssignedLawyer && (
          <>
            <section className="submit-form">
              <SecondaryButton
                title={translate(messages.goBackButton, props)}
                data-testid="go-back"
              />

              <DropDownDecisionMenu
                setDropDown={setDropDown}
                dropDown={dropDown}
                height={'46'}
                label={translate(messages.managerDecisionTitle, props)}
                menuElements={resolveDropDownMenuElements() as any}
              />
            </section>
          </>
        )}
      {featureService.hasFeature(FEATURES.JUDGEMENT_ON_MERITS_CONTESTATION) ? (
        <div>
          <SahamDrawer
            open={isContestationDrawerOpen}
            handleToggleDrawer={() => setIsContestationDrawerOpen(false)}
            title={translate(messages.contestationDrawerTitle, props)}
            confirmButtonTitle={translate(messages.validateButton, props)}
            isDisplayCancelButton
            isDisplayCloseButton
            handleValidateDrawer={handleValidateJudgementOnMerits}
          >
            <FormContainer>
              <FormControl className="formEl">
                <InputLabel>
                  {translate(messages.judgementOnMeritsContestationType, props)}
                </InputLabel>
                <Select
                  onChange={handleFormChange(CONTESTATION.TYPE)}
                  name={CONTESTATION.TYPE}
                  data-testid={CONTESTATION.TYPE}
                  id={CONTESTATION.TYPE}
                  value={get(formContestationValues, [CONTESTATION.TYPE], '')}
                >
                  {get(listings, 'judgementOnMeritsContestationTypes', [])
                    .filter(
                      (el: any) =>
                        (el.displayedFor === PROCEDURE_TYPES.FIRST_INSTANCE ||
                          isNil(el.displayedFor)) &&
                        el.isVisible,
                    )
                    .map((type: Config) => (
                      <MenuItem value={type.id} key={type.id}>
                        {type.title}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </FormContainer>
            {formContestationValues[CONTESTATION.TYPE] === 2 && (
              <FormContainer>
                <FormControl className="formEl">
                  <InputLabel>
                    {translate(
                      messages.judgementOnMeritsContestationWithdrawalReason,
                      props,
                    )}
                  </InputLabel>
                  <Select
                    onChange={handleFormChange(CONTESTATION.WITHDRAWALREASON)}
                    name={CONTESTATION.WITHDRAWALREASON}
                    value={get(
                      formContestationValues,
                      [CONTESTATION.WITHDRAWALREASON],
                      '',
                    )}
                  >
                    {get(
                      listings,
                      'judgementOnMeritsContestationWithdrawalReasons',
                      [],
                    ).map((type: Config) => (
                      <MenuItem value={type.id} key={type.id}>
                        {type.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </FormContainer>
            )}
            <FormContainer>
              <FormControl className="formEl">
                <InputLabel>
                  {translate(
                    messages.judgementOnMeritsContestationOwner,
                    props,
                  )}
                </InputLabel>
                <Select
                  onChange={handleFormChange(CONTESTATION.OWNER)}
                  name={CONTESTATION.OWNER}
                  value={get(formContestationValues, [CONTESTATION.OWNER], '')}
                >
                  {get(listings, 'judgementOnMeritsContestationOwners', []).map(
                    (type: Config) => (
                      <MenuItem value={type.id} key={type.id}>
                        {type.title}
                      </MenuItem>
                    ),
                  )}
                </Select>
              </FormControl>
            </FormContainer>
            <FormContainer>
              <FormControl className="formEl">
                <InputLabel>
                  {translate(
                    messages.judgementOnMeritsContestationAgainst,
                    props,
                  )}
                </InputLabel>
                <Select
                  onChange={handleFormChange(CONTESTATION.AGAINST)}
                  name={CONTESTATION.AGAINST}
                  data-testid={CONTESTATION.AGAINST}
                  value={get(
                    formContestationValues,
                    [CONTESTATION.AGAINST],
                    '',
                  )}
                >
                  <MenuItem value={CONTESTATION_AGAINST.VICTIM} key={0}>
                    {CONTESTATION_AGAINST.VICTIM}
                  </MenuItem>
                  <MenuItem value={CONTESTATION_AGAINST.VEHICLE} key={1}>
                    {CONTESTATION_AGAINST.VEHICLE}
                  </MenuItem>
                </Select>
              </FormControl>
            </FormContainer>
            {formContestationValues[CONTESTATION.AGAINST] ===
              CONTESTATION_AGAINST.VICTIM && (
              <FormContainer>
                <FormGroup>
                  {props.victims.map((victim: VictimType) => (
                    <div>
                      <FormControlLabel
                        key={victim.id}
                        control={
                          <Checkbox
                            data-testid="checkboxId"
                            checked={IsVictimChecked(
                              victim.id as any,
                              selectedVictims,
                            )}
                            color="primary"
                            onChange={handleVictimChangeCheckBox(
                              victim.id as any,
                            )}
                          />
                        }
                        label={
                          featureService.hasFeature(
                            FEATURES.MIGRATION_CLAIM_INFO,
                          )
                            ? `${get(
                                getVictimFromSagisInfo(
                                  get(victim, 'victimKey'),
                                  props.sagisVictimInfo,
                                ),
                                'victimFirstName',
                                '',
                              )} ${get(
                                getVictimFromSagisInfo(
                                  get(victim, 'victimKey'),
                                  props.sagisVictimInfo,
                                ),
                                'victimLastName',
                                '',
                              )}`
                            : getVictimFullName(victim)
                        }
                      />

                      {IsVictimChecked(victim.id as any, selectedVictims) &&
                        get(victim, 'beneficiaries', []).map(
                          (beneficiary: any) => (
                            <div style={{ marginLeft: '20px' }}>
                              <div className="info-item">
                                {translate(
                                  {
                                    ...messages.judgementOnMeritsContestationBeneficiaries,
                                  },
                                  props,
                                )}
                              </div>

                              <FormControlLabel
                                key={beneficiary.id}
                                control={
                                  <Checkbox
                                    name="beneficiary"
                                    checked={isBeneficiaryChecked(
                                      beneficiary.id,
                                    )}
                                    color="primary"
                                    onChange={handleBeneficiaryCheckBox(
                                      victim.id as any,
                                      beneficiary.id,
                                      victim.beneficiaries as any,
                                    )}
                                  />
                                }
                                label={`${beneficiary.firstName} ${beneficiary.lastName}`}
                              />
                            </div>
                          ),
                        )}
                    </div>
                  ))}
                </FormGroup>
              </FormContainer>
            )}
            {formContestationValues[CONTESTATION.AGAINST] ===
              CONTESTATION_AGAINST.VEHICLE && (
              <FormContainer>
                <FormGroup>
                  {props.vehicules.map((vehicule: any, index: number) => (
                    <FormControlLabel
                      key={index}
                      control={
                        <Checkbox
                          data-testid="checkboxId"
                          checked={IsVehicleChecked(
                            vehicule.id,
                            selectedVehicles,
                          )}
                          color="primary"
                          onChange={handleVehicleChangeCheckBox(vehicule.id)}
                        />
                      }
                      label={
                        featureService.hasFeature(
                          FEATURES.MIGRATION_CLAIM_INFO,
                        ) &&
                        !isEmpty(
                          getVehicleFromSagisInfo(
                            get(vehicule, 'partKey'),
                            props.sagisOpposingParties,
                          ),
                        )
                          ? get(
                              getVehicleFromSagisInfo(
                                get(vehicule, 'partKey'),
                                props.sagisOpposingParties,
                              ),
                              'registrationNumber',
                            )
                          : vehicule.registrationNumber
                      }
                    />
                  ))}
                </FormGroup>
              </FormContainer>
            )}
            <FormContainer>
              <FormControl className="formEl">
                <TextField
                  label={translate(
                    {
                      ...messages.judgementOnMeritsContestationCommentary,
                    },
                    props,
                  )}
                  className="formEl"
                  onChange={handleFormChange(CONTESTATION.COMMENTARY)}
                  name={CONTESTATION.COMMENTARY}
                  value={get(formContestationValues, [CONTESTATION.COMMENTARY])}
                />
              </FormControl>
            </FormContainer>
            <FormContainer>
              <FormControl className="formEl">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={IsDifficultyExecutionChecked}
                      color="primary"
                      onChange={handleDifficultyExecutionCheckBox}
                    />
                  }
                  label={translate(
                    messages.judgementOnMeritsContestationDifficultyExecution,
                    props,
                  )}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isDefenseExecutionChecked}
                      color="primary"
                      onChange={handleDefenseExecutionCheckBox}
                    />
                  }
                  label={translate(
                    messages.judgementOnMeritsContestationDefenseExecution,
                    props,
                  )}
                />
              </FormControl>
            </FormContainer>
          </SahamDrawer>
        </div>
      ) : (
        <PrimaryButton
          background={BUTTON_COLORS.PRIMARY_BLUE}
          border={BUTTON_COLORS.PRIMARY_BLUE}
          titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
          title={translate(messages.validateButton, props)}
          onClick={handleValidateJudgementOnMerits}
        />
      )}
      {featureService.hasFeature(FEATURES.ADD_MULTIPLE_JOM) && (
        <AddJomDrawer
          open={isAddJomDrawerOpen}
          victims={
            isPendingApprovalClaim(claimRecap)
              ? props.victims
              : filterVictim(props.victims)
          }
          handleToggleDrawer={handleToggleAddJomDrawer}
          handleSubmit={() => handleSubmitCreateJom()}
          associatedVictims={associatedVictims}
          setAssociatedVictims={setAssociatedVictims}
          vehicles={props.vehicules}
          associatedVehicles={associatedVehicles}
          setAssociatedVehicles={setAssociatedVehicles}
          civilVictimsToInclude={civilVictimsToInclude}
          jomVictimsToInclude={jomVictimsToInclude}
          civilVehiclesToInclude={civilVehiclesToInclude}
          jomVehiclesToInclude={jomVehiclesToInclude}
          isCivilJudiciaryProcess={props.isCivilProceeding}
          jomDeceasedVictims={props.jomDeceasedVictims}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
        />
      )}
      {featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) &&
      !isEmpty(feeNotes) &&
      feeNotes ? (
        feeNotes.map((item: FeeNoteType) => (
          <InvoiceInfoDialog
            open={openInvoiceUpdateFeeNoteInfoDialog}
            onClose={handleCloseInvoiceUpdateFeeNote}
            handleValidate={handleValidateUpdateInvoice}
            invoiceNumber={invoiceNumber}
            invoiceDate={invoiceDate}
            setInvoiceNumber={setInvoiceNumber}
            setInvoiceDate={setInvoiceDate}
            resetUploadedDocument={resetUploadedDocument}
            uploadDocument={uploadDocument}
            uploadedDocument={uploadedDocument}
            invoiceDocument={invoiceDocument}
            setInvoiceDocument={setInvoiceDocument}
            displayUpdateTitle={true}
            isManager={false}
            limitInvoiceDate={getLimitInvoiceIntervenant(
              get(listings, 'appConfig', []),
            )}
          />
        ))
      ) : (
        <></>
      )}
      {isAppealDialogOpen && (
        <Dialog
          open={isAppealDialogOpen}
          handleClose={handleCloseAppealDialog}
          handleValidate={handleValidateAppealDialog}
          title={translate(messages.JudgementAppealTabTitle, props)}
          confirmTitle={translate(messages.confirm, props)}
          cancelTitle={translate(messages.cancel, props)}
        >
          <div className="content">
            {translate(messages.appealMultiple, props)}
          </div>
        </Dialog>
      )}
    </Container>
  ) : (
    <></>
  );
};

export default injectIntl(JudgementOnMerits);
